(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    const init = () => {
      const root = document.querySelector('[data-cart-page]');
      if (!root) return;
      if (document.documentElement.dataset.cartPageReady) return;
      document.documentElement.dataset.cartPageReady = 'true';

      const withJs = (url) => {
        if (!url) return url;
        if (url.indexOf('.js') !== -1) return url;
        return `${url}.js`;
      };

      const liveRoot = () => document.querySelector('[data-cart-page]');

      const updateFromHtml = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-cart-page]');
        const live = liveRoot();
        if (next && live) live.replaceWith(next);
      };

      const changeCart = (key, quantity) => {
        const page = liveRoot();
        if (!page) return;
        const changeUrl = page.getAttribute('data-cart-change-url');
        const sectionId = page.getAttribute('data-section-id');
        page.setAttribute('aria-busy', 'true');

        fetch(withJs(changeUrl), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: Number(quantity),
            sections: sectionId,
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data && data.sections && data.sections[sectionId]) {
              updateFromHtml(data.sections[sectionId]);
            } else {
              throw new Error('section');
            }
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(() => {
            const live = liveRoot();
            if (live) live.removeAttribute('aria-busy');
          });
      };

      document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-cart-page-change]');
        if (!button) return;
        const page = liveRoot();
        if (!page || !page.contains(button)) return;
        event.preventDefault();
        changeCart(button.getAttribute('data-key'), button.getAttribute('data-quantity'));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["client-space"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const STORAGE_KEY = 'decor-berbere-dossiers-v1';
    const LEGACY_KEY = 'db-client-dossiers-v1';
    const PROJECTS_KEY = 'decor-berbere-saved-projects';
    const DESIGN_PROJECTS_KEY = 'decor-berbere-projects-v1';

    const root = document.querySelector('[data-client-space]');
    if (!root) return;
    const configEl = root.querySelector('[data-client-space-config]');
    const config = configEl ? JSON.parse(configEl.textContent) : {};

    const listEl = root.querySelector('[data-client-space-list]');
    const threadEl = root.querySelector('[data-client-space-thread]');
    const missingEl = root.querySelector('[data-client-space-missing]');
    const titleEl = root.querySelector('[data-client-space-title]');
    const noteEl = root.querySelector('[data-client-space-note]');
    const errorEl = root.querySelector('[data-client-space-error]');
    const dossiersEl = root.querySelector('[data-client-space-dossiers]');
    const emptyEl = root.querySelector('[data-client-space-exchanges-empty]');
    const exchangesTitle = root.querySelector('[data-client-space-exchanges-title]');
    const projectsGrid = root.querySelector('[data-client-space-projects]');
    const projectsEmpty = root.querySelector('[data-client-space-projects-empty]');
    const projectsStatus = root.querySelector('[data-client-space-projects-status]');
    const messagesEl = root.querySelector('[data-client-space-messages]');
    const accessEl = root.querySelector('[data-client-space-access]');
    const noticeEl = root.querySelector('[data-client-space-notice]');
    const threadContext = root.querySelector('[data-client-space-thread-context]');
    const headingDefault = titleEl ? titleEl.textContent : '';

    let dossiers = [];
    let currentId = '';

    const formatDate = (value) => {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      return date.toLocaleDateString('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    };

    const showError = (el, message) => {
      if (!el) return;
      if (message) {
        el.hidden = false;
        el.textContent = message;
      } else {
        el.hidden = true;
        el.textContent = '';
      }
    };

    const readStore = (storage, key) => {
      const raw = storage.getItem(key);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (parsed && parsed.version === 1 && Array.isArray(parsed.dossiers)) return parsed.dossiers;
      if (Array.isArray(parsed)) return parsed;
      return [];
    };

    const loadDossiers = () => {
      let loaded = [];
      try {
        loaded = readStore(localStorage, STORAGE_KEY);
      } catch (error) {
        loaded = [];
      }
      if (!loaded.length) {
        try {
          loaded = readStore(sessionStorage, LEGACY_KEY);
        } catch (error) {
          loaded = [];
        }
      }
      return loaded.filter((item) => item && typeof item.id === 'string');
    };

    const saveDossiers = (next) => {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ version: 1, dossiers: next }));
    };

    const newId = (prefix) =>
      prefix +
      Math.random().toString(16).slice(2, 10).toUpperCase().padEnd(8, '0').slice(0, 8);

    const currentDossier = () => dossiers.find((item) => item.id === currentId);

    const setView = (id) => {
      currentId = id || '';
      const url = new URL(window.location.href);
      if (currentId) url.searchParams.set('demande', currentId);
      else url.searchParams.delete('demande');
      history.replaceState(history.state, '', url);
      render();
    };

    const renderProjects = async () => {
      if (!projectsGrid) return;
      let items = [];
      try {
        const simple = JSON.parse(localStorage.getItem(PROJECTS_KEY) || '[]');
        if (Array.isArray(simple)) {
          items = simple.map((item, index) => {
            if (typeof item === 'string') {
              return { id: item, handle: item, updatedAt: String(index) };
            }
            return {
              id: item.handle || String(index),
              handle: item.handle,
              title: item.title,
              family: item.family,
              image: item.image || item._custom_image,
              url: item.url,
              updatedAt: item.savedAt || String(index)
            };
          });
        }
      } catch (error) {
        if (projectsStatus) projectsStatus.textContent = config.projectsError || '';
      }
      try {
        const design = JSON.parse(localStorage.getItem(DESIGN_PROJECTS_KEY) || 'null');
        if (design && Array.isArray(design.projects)) {
          design.projects.forEach((entry) => {
            const project = entry.project || {};
            if (!project.productSlug) return;
            items.push({
              id: entry.id || project.productSlug,
              handle: project.productSlug,
              title: project.name,
              family: project.family,
              image: project.image,
              url: '/products/' + project.productSlug,
              updatedAt: entry.updatedAt || ''
            });
          });
        }
      } catch (error) {}

      const unique = [];
      const seen = new Set();
      items.forEach((item) => {
        const key = item.handle || item.id;
        if (!key || seen.has(key)) return;
        seen.add(key);
        unique.push(item);
      });

      const cards = await Promise.all(
        unique.map(async (item) => {
          if (item.title && item.image) return item;
          if (!item.handle) return item;
          try {
            const response = await fetch('/products/' + encodeURIComponent(item.handle) + '.js');
            if (!response.ok) return item;
            const product = await response.json();
            return {
              ...item,
              title: item.title || product.title,
              image: item.image || (product.featured_image ? product.featured_image : ''),
              url: item.url || product.url,
              family: item.family || product.type || product.vendor || ''
            };
          } catch (error) {
            return item;
          }
        })
      );

      if (projectsStatus) projectsStatus.hidden = true;
      projectsGrid.innerHTML = '';
      if (!cards.length) {
        projectsGrid.hidden = true;
        if (projectsEmpty) projectsEmpty.hidden = false;
        return;
      }
      if (projectsEmpty) projectsEmpty.hidden = true;
      projectsGrid.hidden = false;
      cards
        .sort((a, b) => String(b.updatedAt).localeCompare(String(a.updatedAt)))
        .forEach((item) => {
          const article = document.createElement('article');
          article.className = 'client-space__project';
          const photo = document.createElement('div');
          photo.className = 'client-space__project-photo';
          if (item.image) {
            const img = document.createElement('img');
            img.src = item.image;
            img.alt = item.title || config.projectImageAlt || '';
            img.loading = 'lazy';
            img.width = 88;
            img.height = 112;
            photo.appendChild(img);
          }
          const details = document.createElement('div');
          details.className = 'client-space__project-details';
          const name = document.createElement('h3');
          name.textContent = item.title || item.handle || '';
          details.appendChild(name);
          if (item.family) {
            const family = document.createElement('p');
            family.textContent = item.family;
            details.appendChild(family);
          }
          const resume = document.createElement('a');
          resume.className = 'client-space__resume';
          resume.href = item.url || '/products/' + item.handle;
          resume.textContent = config.resumeLabel || '';
          details.appendChild(resume);
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'client-space__remove';
          remove.textContent = config.removeLabel || '';
          remove.setAttribute('aria-label', (config.removeNamed || '') + ' ' + name.textContent);
          remove.addEventListener('click', () => {
            try {
              const simple = JSON.parse(localStorage.getItem(PROJECTS_KEY) || '[]');
              const next = (Array.isArray(simple) ? simple : []).filter((entry) => {
                const handle = typeof entry === 'string' ? entry : entry.handle;
                return handle !== item.handle;
              });
              localStorage.setItem(PROJECTS_KEY, JSON.stringify(next));
              renderProjects();
            } catch (error) {
              if (projectsStatus) {
                projectsStatus.hidden = false;
                projectsStatus.textContent = config.projectsError || '';
              }
            }
          });
          details.appendChild(remove);
          article.appendChild(photo);
          article.appendChild(details);
          projectsGrid.appendChild(article);
        });
    };

    const renderList = () => {
      if (!dossiersEl || !emptyEl) return;
      const sorted = [...dossiers].sort((a, b) => String(b.updatedAt || '').localeCompare(String(a.updatedAt || '')));
      if (exchangesTitle) {
        exchangesTitle.textContent = sorted.length ? config.exchangesHeadingList : config.exchangesHeading;
      }
      dossiersEl.innerHTML = '';
      if (!sorted.length) {
        dossiersEl.hidden = true;
        emptyEl.hidden = false;
        return;
      }
      dossiersEl.hidden = false;
      emptyEl.hidden = true;
      sorted.forEach((item) => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = '?demande=' + encodeURIComponent(item.id);
        link.addEventListener('click', (event) => {
          event.preventDefault();
          setView(item.id);
        });
        const top = document.createElement('div');
        top.className = 'client-space__card-top';
        const kind = document.createElement('span');
        kind.textContent = (config.kinds && config.kinds[item.kind]) || item.kind || '';
        const status = document.createElement('span');
        status.className = 'client-space__status';
        status.setAttribute('data-status', item.status || 'waiting_db');
        status.textContent = (config.statuses && config.statuses[item.status]) || '';
        top.appendChild(kind);
        top.appendChild(status);
        const heading = document.createElement('h3');
        heading.textContent = item.subject || '';
        const excerpt = document.createElement('p');
        excerpt.className = 'client-space__excerpt';
        const last = (item.messages || [])[item.messages.length - 1];
        excerpt.textContent = (last && last.body) || config.attachmentAdded || '';
        const bottom = document.createElement('div');
        bottom.className = 'client-space__card-bottom';
        const time = document.createElement('time');
        time.dateTime = item.updatedAt || '';
        time.textContent = formatDate(item.updatedAt);
        const read = document.createElement('span');
        read.textContent = config.readLabel || '';
        bottom.appendChild(time);
        bottom.appendChild(read);
        link.appendChild(top);
        link.appendChild(heading);
        link.appendChild(excerpt);
        link.appendChild(bottom);
        li.appendChild(link);
        dossiersEl.appendChild(li);
      });
    };

    const renderThread = (dossier) => {
      if (!messagesEl) return;
      if (titleEl) titleEl.textContent = dossier.subject || headingDefault;
      if (accessEl) accessEl.hidden = dossier.kind !== 'access';
      messagesEl.innerHTML = '';
      (dossier.messages || []).forEach((message) => {
        const li = document.createElement('li');
        li.setAttribute('data-author', message.author || 'client');
        const meta = document.createElement('div');
        meta.className = 'client-space__message-meta';
        const author = document.createElement('strong');
        author.textContent = message.author === 'db' ? config.atelier : config.you;
        const time = document.createElement('time');
        time.dateTime = message.createdAt || '';
        time.textContent = formatDate(message.createdAt);
        meta.appendChild(author);
        meta.appendChild(time);
        li.appendChild(meta);
        if (message.author === 'db' && dossier.demo) {
          const badge = document.createElement('span');
          badge.className = 'client-space__demo-reply';
          badge.textContent = config.demoReply || '';
          li.appendChild(badge);
        }
        if (message.body) {
          const body = document.createElement('p');
          body.textContent = message.body;
          li.appendChild(body);
        }
        if (message.attachments && message.attachments.length) {
          const files = document.createElement('ul');
          files.className = 'client-space__files';
          message.attachments.forEach((file) => {
            const item = document.createElement('li');
            if (file.type && file.type.indexOf('image/') === 0 && file.data) {
              const img = document.createElement('img');
              img.src = file.data;
              img.alt = file.name || '';
              img.loading = 'lazy';
              item.appendChild(img);
            }
            const link = document.createElement('a');
            link.href = file.data || '#';
            link.download = file.name || 'fichier';
            link.textContent = file.name || '';
            item.appendChild(link);
            files.appendChild(item);
          });
          li.appendChild(files);
        }
        messagesEl.appendChild(li);
      });
      if (noticeEl) {
        noticeEl.hidden = dossier.status !== 'resolved';
        noticeEl.textContent = dossier.status === 'resolved' ? config.resolvedNotice : '';
      }
      if (threadContext) {
        threadContext.innerHTML = '';
        const eyebrow = document.createElement('p');
        eyebrow.className = 'client-space__eyebrow';
        eyebrow.textContent = (config.kinds && config.kinds[dossier.kind]) || '';
        threadContext.appendChild(eyebrow);
        if (dossier.orderId) {
          const order = document.createElement('p');
          order.textContent = dossier.orderId;
          threadContext.appendChild(order);
        }
        const track = document.createElement('a');
        track.className = 'client-space__text-link';
        if (dossier.kind === 'order') {
          track.href = config.trackingUrl || '/pages/suivi';
          track.textContent = config.trackOrder || '';
        } else if (dossier.returnHref) {
          track.href = dossier.returnHref;
          track.textContent = config.resumeChoices || '';
        } else {
          track.href = config.contactUrl || '/pages/contact';
          track.textContent = config.resumeChoices || '';
        }
        threadContext.appendChild(track);
        if (dossier.context) {
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          summary.textContent = config.requestInfo || '';
          const text = document.createElement('p');
          text.className = 'client-space__context-text';
          text.textContent = dossier.context;
          details.appendChild(summary);
          details.appendChild(text);
          threadContext.appendChild(details);
        }
        const download = document.createElement('button');
        download.type = 'button';
        download.className = 'client-space__text-link';
        download.textContent = config.downloadLabel || '';
        download.addEventListener('click', () => {
          const lines = [
            dossier.id,
            dossier.subject,
            (dossier.messages || [])
              .map((message) => {
                const who = message.author === 'db' ? config.atelier : config.you;
                return who + ' · ' + formatDate(message.createdAt) + '\n' + (message.body || '');
              })
              .join('\n\n')
          ];
          const blob = new Blob([lines.filter(Boolean).join('\n\n')], { type: 'text/plain' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = dossier.id + '-echange.txt';
          link.click();
          URL.revokeObjectURL(url);
        });
        threadContext.appendChild(download);
        if (dossier.status !== 'resolved') {
          const resolve = document.createElement('button');
          resolve.type = 'button';
          resolve.className = 'client-space__text-link';
          resolve.textContent = config.resolveLabel || '';
          resolve.addEventListener('click', () => {
            dossier.status = 'resolved';
            dossier.updatedAt = new Date().toISOString();
            saveDossiers(dossiers);
            render();
          });
          threadContext.appendChild(resolve);
          const hint = document.createElement('p');
          hint.className = 'client-space__hint';
          hint.textContent = config.resolveHint || '';
          threadContext.appendChild(hint);
        }
      }
    };

    const render = () => {
      const dossier = currentDossier();
      if (!currentId) {
        if (listEl) listEl.hidden = false;
        if (threadEl) threadEl.hidden = true;
        if (missingEl) missingEl.hidden = true;
        if (noteEl) noteEl.hidden = false;
        if (titleEl) titleEl.textContent = headingDefault;
        showError(errorEl, '');
        renderList();
        return;
      }
      if (noteEl) noteEl.hidden = true;
      if (!dossier) {
        if (listEl) listEl.hidden = true;
        if (threadEl) threadEl.hidden = true;
        if (missingEl) missingEl.hidden = false;
        return;
      }
      if (listEl) listEl.hidden = true;
      if (missingEl) missingEl.hidden = true;
      if (threadEl) threadEl.hidden = false;
      renderThread(dossier);
    };

    try {
      dossiers = loadDossiers();
    } catch (error) {
      showError(errorEl, config.loadError || '');
    }

    currentId = new URLSearchParams(window.location.search).get('demande') || '';
    render();
    renderProjects();

    const missingBack = root.querySelector('[data-client-space-missing-back]');
    if (missingBack) missingBack.addEventListener('click', () => setView(''));

    const demoBtn = root.querySelector('[data-client-space-demo]');
    if (demoBtn) {
      demoBtn.addEventListener('click', () => {
        const now = new Date().toISOString();
        const id = newId('DB-');
        const dossier = {
          id: id,
          subject: config.demoSubject || '',
          kind: 'contact',
          returnHref: config.rugsUrl || '',
          createdAt: now,
          updatedAt: now,
          status: 'waiting_client',
          demo: true,
          messages: [
            {
              id: id + '-initial',
              author: 'client',
              body: config.demoMessage || '',
              createdAt: now,
              attachments: []
            },
            {
              id: newId('MSG-'),
              author: 'db',
              body: config.demoAnswer || '',
              createdAt: now,
              attachments: []
            }
          ]
        };
        try {
          const next = dossiers.concat(dossier);
          saveDossiers(next);
          dossiers = next;
          showError(errorEl, '');
          setView(id);
        } catch (error) {
          showError(errorEl, config.demoError || '');
        }
      });
    }

    window.addEventListener('storage', (event) => {
      if (event.key === STORAGE_KEY || event.key === PROJECTS_KEY) {
        try {
          dossiers = loadDossiers();
          render();
          renderProjects();
        } catch (error) {
          showError(errorEl, config.loadError || '');
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-interior"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__sizeGuideSection) return;
    window.__sizeGuideSection = true;

    const syncGuideDimension = (dialog, dimension) => {
      if (!dialog) return;
      const value = dimension || '';
      const select = dialog.querySelector('[data-size-guide-dimension]');
      if (select) {
        if (value === '' || Array.from(select.options).some((option) => option.value === value)) {
          select.value = value;
        }
      }
      dialog.querySelectorAll('[data-size-guide-chip]').forEach((chip) => {
        chip.setAttribute('aria-pressed', chip.getAttribute('data-size-guide-chip') === value ? 'true' : 'false');
      });
    };

    const setGuideDimension = (dialog, dimension) => {
      if (!dialog) return;
      const value = dimension || '';
      const select = dialog.querySelector('[data-size-guide-dimension]');
      if (select && value && !Array.from(select.options).some((option) => option.value === value)) {
        const chip = dialog.querySelector(`[data-size-guide-chip="${value}"]`);
        const option = document.createElement('option');
        option.value = value;
        option.textContent = chip ? chip.textContent.trim() : value;
        select.append(option);
      }
      syncGuideDimension(dialog, value);
    };

    const openDialog = (selector) => {
      if (!selector) return;
      const dialog = document.querySelector(selector);
      if (!dialog) return;
      const sizeFilter = document.querySelector('[data-size-filter]');
      syncGuideDimension(dialog, sizeFilter ? sizeFilter.value : '');
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      const focusable = dialog.querySelector('[data-dialog-focus]');
      if (focusable) focusable.focus();
    };

    const closeDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    const showRoom = (dialog, roomId) => {
      if (!dialog || !roomId) return;
      dialog.querySelectorAll('[data-size-guide-tab]').forEach((tab) => {
        tab.setAttribute('aria-pressed', tab.getAttribute('data-size-guide-tab') === roomId ? 'true' : 'false');
      });
      dialog.querySelectorAll('[data-size-guide-panel]').forEach((panel) => {
        panel.hidden = panel.getAttribute('data-size-guide-panel') !== roomId;
      });
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-size-guide-open]');
      if (opener) {
        openDialog(opener.getAttribute('data-size-guide-open'));
        return;
      }

      const tab = event.target.closest('[data-size-guide-tab]');
      if (tab) {
        showRoom(tab.closest('dialog'), tab.getAttribute('data-size-guide-tab'));
        return;
      }

      const chip = event.target.closest('[data-size-guide-chip]');
      if (chip) {
        setGuideDimension(chip.closest('dialog'), chip.getAttribute('data-size-guide-chip') || '');
        return;
      }

      const applier = event.target.closest('[data-size-guide-apply]');
      if (applier) {
        const dialog = applier.closest('dialog');
        const select = dialog ? dialog.querySelector('[data-size-guide-dimension]') : null;
        document.dispatchEvent(
          new CustomEvent('collection:set-dimension', {
            detail: {
              dimension: select ? select.value : '',
              label:
                select && select.selectedOptions && select.selectedOptions[0]
                  ? select.selectedOptions[0].textContent.trim()
                  : '',
            },
          })
        );
        closeDialog(dialog);
        return;
      }

      const closer = event.target.closest('[data-size-guide-close]');
      if (closer) {
        closeDialog(closer.closest('dialog'));
      }
    });

    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-size-guide-dimension]');
      if (!select) return;
      syncGuideDimension(select.closest('dialog'), select.value);
    });

    document.addEventListener('click', (event) => {
      const dialog = event.target;
      if (dialog && dialog.matches && dialog.matches('dialog.size-guide-dialog')) {
        closeDialog(dialog);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guide-dimensions"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__guideDimensionsSection) return;
    window.__guideDimensionsSection = true;

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-guide-room]');
      if (!tab) return;
      const root = tab.closest('[data-guide-dimensions]');
      if (!root) return;
      const roomId = tab.getAttribute('data-guide-room');
      root.querySelectorAll('[data-guide-room]').forEach((button) => {
        button.setAttribute('aria-pressed', button.getAttribute('data-guide-room') === roomId ? 'true' : 'false');
      });
      root.querySelectorAll('[data-guide-room-panel]').forEach((panel) => {
        panel.hidden = panel.getAttribute('data-guide-room-panel') !== roomId;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.__decorHeaderEvents) return;
    window.__decorHeaderEvents = true;

    const openDialog = (selector) => {
      const dialog = document.querySelector(selector);
      if (!dialog) return;
      dialog.classList.remove('is-closing');
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      const focusable = dialog.querySelector('[data-dialog-focus]');
      if (focusable) focusable.focus();
    };

    const closeDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    const isHeaderSurface = (element) =>
      element instanceof HTMLDialogElement &&
      (element.classList.contains('header-dialog') ||
        element.classList.contains('search-dialog') ||
        element.classList.contains('cart-drawer'));

    document.addEventListener('click', (event) => {
      const origin = event.target instanceof Element ? event.target : event.target.parentElement;
      if (!origin) return;

      const opener = origin.closest('[data-header-open]');
      if (opener) {
        openDialog(opener.getAttribute('data-header-open'));
        return;
      }

      const closer = origin.closest('[data-header-close]');
      if (closer) {
        closeDialog(closer.closest('dialog'));
        return;
      }

      const dialog = event.target;
      if (isHeaderSurface(dialog) && dialog.dataset.backdropPointer === 'true') {
        closeDialog(dialog);
      }
    });

    document.addEventListener(
      'pointerdown',
      (event) => {
        const dialog = event.target instanceof HTMLDialogElement ? event.target : null;
        if (isHeaderSurface(dialog)) {
          dialog.dataset.backdropPointer = 'true';
        } else {
          document
            .querySelectorAll('dialog.header-dialog[open], dialog.search-dialog[open], dialog.cart-drawer[open]')
            .forEach((openDialogEl) => {
              openDialogEl.dataset.backdropPointer = 'false';
            });
        }
      },
      true
    );

    const bindHover = () => {
      const header = document.querySelector('[data-header]');
      if (!header) return;

      const closeOpenMenus = (except) => {
        header.querySelectorAll('details[open]').forEach((details) => {
          if (details !== except) details.open = false;
        });
      };

      if (window.matchMedia('(hover: hover)').matches) {
        header.querySelectorAll('.header__item--has-children, .header__account').forEach((item) => {
          const details = item.querySelector('details');
          if (!details) return;
          item.addEventListener('mouseenter', () => {
            closeOpenMenus(details);
            details.open = true;
          });
          item.addEventListener('mouseleave', () => {
            details.open = false;
          });
        });
      }

      header.querySelectorAll('.header__account-menu').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (details.open) closeOpenMenus(details);
        });
      });

      document.addEventListener('click', (event) => {
        const origin = event.target instanceof Element ? event.target : null;
        header.querySelectorAll('.header__account-menu[open]').forEach((details) => {
          if (!origin || !details.contains(origin)) details.open = false;
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindHover);
    } else {
      bindHover();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interiors"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__interiorsLightbox) return;
    window.__interiorsLightbox = true;

    const openDialog = (selector) => {
      if (!selector) return;
      const dialog = document.querySelector(selector);
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      const focusable = dialog.querySelector('[data-dialog-focus]');
      if (focusable) focusable.focus();
    };

    const closeDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-interior-open]');
      if (opener) {
        openDialog(opener.getAttribute('data-interior-open'));
        return;
      }

      const closer = event.target.closest('[data-interior-close]');
      if (closer) {
        closeDialog(closer.closest('dialog'));
      }
    });

    document.addEventListener('click', (event) => {
      const dialog = event.target;
      if (dialog && dialog.matches && dialog.matches('dialog.interiors-dialog')) {
        closeDialog(dialog);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.legal__references a[href^="http"]').forEach((link) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-at-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productAtHome) return;
    window.__productAtHome = true;

    const openDialog = (selector) => {
      if (!selector) return;
      const dialog = document.querySelector(selector);
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      const focusable = dialog.querySelector('[data-dialog-focus]');
      if (focusable) focusable.focus();
    };

    const closeDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-at-home-open]');
      if (opener) {
        openDialog(opener.getAttribute('data-at-home-open'));
        return;
      }

      const closer = event.target.closest('[data-at-home-close]');
      if (closer) {
        closeDialog(closer.closest('dialog'));
        return;
      }

      const dialog = event.target;
      if (dialog && dialog.matches && dialog.matches('dialog.product-at-home-dialog')) {
        closeDialog(dialog);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-echantillons"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-sample-kit]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const params = new URLSearchParams(window.location.search);
    const mode = root.getAttribute('data-color-mode') || 'single';
    const productUrl = root.getAttribute('data-product-url') || '';
    const futureSize = root.getAttribute('data-future-size') || '';
    const futureSizeChosen = root.getAttribute('data-future-size-chosen') || '';
    const colourSelect = root.querySelector('[data-sample-colour-select]');
    const patternSelect = root.querySelector('[data-sample-pattern-select]');
    const colourInput = root.querySelector('[data-sample-colour]');
    const hexInput = root.querySelector('[data-sample-hex]');
    const groundInput = root.querySelector('[data-sample-ground]');
    const patternInput = root.querySelector('[data-sample-pattern]');
    const sizeInput = root.querySelector('[data-sample-size]');
    const sizeLabel = root.querySelector('[data-sample-size-label]');
    const colourLabel = root.querySelector('[data-sample-colour-label]');
    const patternLabel = root.querySelector('[data-sample-pattern-label]');
    const returnLink = root.querySelector('[data-sample-return]');
    const backLink = root.querySelector('.sample-kit__back');
    const colorsNode = root.querySelector('[data-sample-colors]');
    let colors = [];
    try {
      colors = JSON.parse(colorsNode ? colorsNode.textContent : '[]') || [];
    } catch (error) {
      colors = [];
    }

    const hexOf = (name) => {
      const color = colors.find((item) => item.name === name);
      return (color && color.hex) || '';
    };

    const paint = (slot, name) => {
      const chip = root.querySelector('[data-sample-chip="' + slot + '"]');
      if (!chip) return;
      chip.style.backgroundColor = hexOf(name) || '#eee6d7';
    };

    const currentSize = () => params.get('size') || params.get('dimensions') || '';
    const incomingPile = params.get('pile') || params.get('velours') || params.get('hauteur') || '';
    const incomingFringes = params.get('fringes') || params.get('franges') || '';

    const choiceParams = () => {
      const next = new URLSearchParams();
      const size = currentSize();
      const colour = colourSelect ? colourSelect.value : '';
      const pattern = patternSelect ? patternSelect.value : '';
      if (size) next.set('size', size);
      if (incomingPile) next.set('pile', incomingPile);
      if (incomingFringes) next.set('fringes', incomingFringes);
      if (mode === 'dual') {
        if (colour) next.set('ground', colour);
        if (pattern) next.set('pattern', pattern);
      } else if (colour) {
        next.set('colour', colour);
      }
      return next;
    };

    const withChoices = (base) => {
      const query = choiceParams().toString();
      if (!base) return query ? '?' + query : '';
      return query ? base.split('?')[0] + '?' + query : base.split('?')[0];
    };

    const sync = () => {
      const colour = colourSelect ? colourSelect.value : '';
      const pattern = patternSelect ? patternSelect.value : '';
      const size = currentSize();
      if (colourInput) colourInput.value = colour;
      if (hexInput) hexInput.value = hexOf(colour);
      if (groundInput) groundInput.value = colour;
      if (patternInput) patternInput.value = pattern;
      if (sizeInput) {
        sizeInput.value = size;
        sizeInput.disabled = !size;
      }
      if (colourLabel) colourLabel.textContent = colour;
      if (patternLabel) patternLabel.textContent = pattern;
      paint('ground', colour);
      paint('pattern', pattern);
      if (sizeLabel) {
        sizeLabel.textContent = size
          ? futureSizeChosen.replace('[size]', size)
          : futureSize;
      }
      const href = withChoices(productUrl);
      if (returnLink) returnLink.href = href;
      if (backLink) backLink.href = href;
    };

    const selectValue = (select, value) => {
      if (!select || !value) return;
      const match = [...select.options].find((option) => option.value.toLowerCase() === value.toLowerCase());
      if (match) select.value = match.value;
    };

    selectValue(colourSelect, params.get('colour') || params.get('color') || params.get('ground'));
    selectValue(patternSelect, params.get('pattern'));

    if (colourSelect) colourSelect.addEventListener('change', sync);
    if (patternSelect) patternSelect.addEventListener('change', sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const page = document.querySelector('[data-product-page]');
    if (!page || page.dataset.productReady) return;
    page.dataset.productReady = 'true';

    const forSizeTemplate = page.getAttribute('data-for-size') || '';
    const addLabel = page.getAttribute('data-add-label') || '';
    const addWithPrice = page.getAttribute('data-add-with-price') || '';
    const soldLabel = page.getAttribute('data-sold-label') || '';
    const form = page.querySelector('[data-product-form]');
    const variantInput = page.querySelector('[data-product-variant-id]');
    const sizeProperty = page.querySelector('[data-product-size-property]');
    const priceNodes = page.querySelectorAll('[data-product-price]');
    const pricePrefix = page.querySelector('[data-product-price-prefix]');
    const sizeNotes = page.querySelectorAll('[data-product-size-note]');
    const ctaButtons = page.querySelectorAll('[data-product-cta]');
    const ctaLabels = page.querySelectorAll('[data-product-cta-label]');
    const sizeError = page.querySelector('[data-product-size-error]');
    const gallery = page.querySelector('[data-product-gallery]');
    const dots = page.querySelectorAll('[data-product-page-dot]');
    const lightbox = page.querySelector('[data-product-lightbox]');
    const lightboxStage = page.querySelector('[data-product-lightbox-stage]');
    const slides = page.querySelectorAll('[data-product-lightbox-slide]');
    const lightboxCount = page.querySelector('[data-product-lightbox-count]');
    const lightboxCaption = page.querySelector('[data-product-lightbox-caption]');
    const lightboxSpinner = page.querySelector('[data-product-lightbox-spinner]');
    const zoomInButton = page.querySelector('[data-product-lightbox-zoom-in]');
    const zoomOutButton = page.querySelector('[data-product-lightbox-zoom-out]');
    const zoomResetButton = page.querySelector('[data-product-lightbox-zoom-reset]');
    const zoomLabel = page.querySelector('[data-product-lightbox-zoom-label]');
    const mobileBar = page.querySelector('[data-product-mobile-bar]');
    const cta = page.querySelector('.product-cta');
    const widthInput = page.querySelector('[data-product-width]');
    const lengthInput = page.querySelector('[data-product-length]');
    const customBox = page.querySelector('[data-product-custom]');
    const widthError = page.querySelector('[data-product-width-error]');
    const lengthError = page.querySelector('[data-product-length-error]');
    const widthSuggestions = page.querySelector('[data-product-width-suggestions]');
    const lengthSuggestions = page.querySelector('[data-product-length-suggestions]');
    const proportionShape = page.querySelector('[data-product-proportion]');
    const proportionWidth = page.querySelector('[data-product-proportion-width]');
    const proportionLength = page.querySelector('[data-product-proportion-length]');
    const proportionFigure = page.querySelector('[data-product-proportion-figure]');
    const customPriceInput = page.querySelector('[data-custom-price]');
    const customSizeLine = page.querySelector('[data-custom-size-line]');
    const customPriceCentsInput = page.querySelector('[data-custom-price-cents]');
    const customSizePrice = page.querySelector('[data-custom-size-price]');
    const customSizeTotal = page.querySelector('[data-custom-size-total]');
    let lightboxIndex = 0;
    let lightboxLoadToken = 0;
    const zoomMin = 1;
    const zoomMax = 4;
    const zoomStep = 0.35;
    let zoomScale = 1;
    let zoomX = 0;
    let zoomY = 0;
    let dragPointerId = null;
    let dragStartX = 0;
    let dragStartY = 0;
    let dragOriginX = 0;
    let dragOriginY = 0;
    let pinchStartDistance = 0;
    let pinchStartScale = 1;
    let didDrag = false;

    const customMin = Number((customBox && customBox.getAttribute('data-min-dimension')) || 60);
    const customMaxWidth = Number((customBox && customBox.getAttribute('data-max-width')) || 800);
    const customStep = Number((customBox && customBox.getAttribute('data-dimension-step')) || 5);
    const emptyMark = (customBox && customBox.getAttribute('data-empty-mark')) || '…';
    const unitLabel = (customBox && customBox.getAttribute('data-unit')) || 'cm';
    const widthWord = (customBox && customBox.getAttribute('data-width-word')) || 'width';
    const lengthWord = (customBox && customBox.getAttribute('data-length-word')) || 'length';

    const formatSizeNote = (size) => {
      if (!size) return '';
      return forSizeTemplate.replace('__SIZE__', size);
    };

    const syncSampleLinks = () => {
      const links = document.querySelectorAll('[data-sample-product-link]');
      if (!links.length) return;
      const params = new URLSearchParams();
      const sizeButton = page.querySelector('[data-product-size][data-active="true"]');
      const size =
        (sizeProperty && sizeProperty.value) ||
        (sizeButton && sizeButton.getAttribute('data-size')) ||
        '';
      const pile = (page.querySelector('[data-product-pile-property]') || {}).value || '';
      const fringes = (page.querySelector('[data-wool-fringes]') || {}).value || '';
      const single = (page.querySelector('[data-wool-single]') || {}).value || '';
      const ground = (page.querySelector('[data-wool-ground]') || {}).value || '';
      const pattern = (page.querySelector('[data-wool-pattern]') || {}).value || '';
      if (page.getAttribute('data-mode') === 'custom' && widthInput && lengthInput) {
        const width = String(widthInput.value || '').trim();
        const length = String(lengthInput.value || '').trim();
        if (width && length) params.set('size', width + ' × ' + length + ' cm');
      } else if (size) {
        params.set('size', size);
      }
      if (pile) params.set('pile', pile);
      if (fringes) params.set('fringes', fringes);
      if (single) params.set('colour', single);
      if (ground) params.set('ground', ground);
      if (pattern) params.set('pattern', pattern);
      const query = params.toString();
      links.forEach((link) => {
        const base = (link.getAttribute('data-sample-product-link') || link.href || '').split('&')[0];
        link.href = query ? base + (base.indexOf('?') === -1 ? '?' : '&') + query : base;
      });
    };

    const editingCartLine = () => Boolean(new URLSearchParams(window.location.search).get('line'));

    document.addEventListener('product:choices', () => {
      syncSampleLinks();
      if (editingCartLine()) setAvailability(true);
    });

    const normalizePile = (value) =>
      String(value || '')
        .toLowerCase()
        .replace(/,/g, '.')
        .replace(/\s+/g, ' ')
        .trim();

    const applyPile = (value) => {
      if (!value) return;
      const wanted = normalizePile(value);
      const pileInput = page.querySelector('[data-product-pile-property]');
      let matched = '';
      page.querySelectorAll('[data-product-pile-option]').forEach((button) => {
        const option = button.getAttribute('data-pile-value') || '';
        const active = normalizePile(option) === wanted;
        if (active) matched = option;
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (pileInput) pileInput.value = matched || value;
      if (editingCartLine()) setAvailability(true);
      syncSampleLinks();
    };

    const applyFringes = (value) => {
      if (!value) return;
      const wanted = String(value).trim().toLowerCase();
      page.querySelectorAll('[data-fringe-option]').forEach((button) => {
        const option = button.getAttribute('data-fringe-option') || '';
        const active = option.trim().toLowerCase() === wanted;
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) {
          const input = page.querySelector('[data-wool-fringes]');
          if (input) input.value = option;
        }
      });
    };

    const parseDimensions = (size) => {
      const match = String(size || '')
        .toLowerCase()
        .replace(/[×✕]/g, 'x')
        .match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/);
      if (!match) return null;
      return {
        width: match[1].replace(',', '.'),
        length: match[2].replace(',', '.')
      };
    };

    const cartJsUrl = (url) => {
      if (!url) return url;
      return url.indexOf('.js') === -1 ? `${url}.js` : url;
    };

    const clearCartEditParams = () => {
      const url = new URL(window.location.href);
      [
        'line',
        'qty',
        'custom',
        'width',
        'length',
        'size',
        'dimensions',
        'ground',
        'pattern',
        'colour',
        'color',
        'fringes',
        'pile',
        'velours',
        'hauteur',
        'variant'
      ].forEach((key) => {
        url.searchParams.delete(key);
      });
      const search = url.searchParams.toString();
      window.history.replaceState({}, '', url.pathname + (search ? `?${search}` : '') + url.hash);
    };

    const replaceCartLine = (lineKey) => {
      const params = new URLSearchParams(window.location.search);
      const quantity = Math.max(1, Number(params.get('qty')) || 1);
      const addUrl = cartJsUrl(page.getAttribute('data-cart-add-url') || '/cart/add');
      const changeUrl = cartJsUrl(page.getAttribute('data-cart-change-url') || '/cart/change');
      const formData = new FormData(form);
      formData.set('quantity', String(quantity));
      ctaButtons.forEach((button) => {
        button.disabled = true;
      });

      const changeLine = (id, nextQuantity) => {
        const drawer = document.querySelector('[data-cart-drawer]');
        const sectionId = drawer && drawer.getAttribute('data-section-id');
        const body = { id, quantity: nextQuantity };
        if (sectionId) {
          body.sections = sectionId;
          body.sections_url = window.location.pathname;
        }
        return fetch(changeUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        }).then((response) => {
          if (!response.ok) throw new Error('change');
          return response.json();
        });
      };

      return fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
        .then(({ ok, data }) => {
          if (!ok || !data || data.status) throw new Error('add');
          const addedKey = data.key || '';
          if (addedKey === lineKey) return changeLine(lineKey, quantity);
          return changeLine(lineKey, 0);
        })
        .then((cart) => {
          clearCartEditParams();
          const drawer = document.querySelector('[data-cart-drawer]');
          const sectionId = drawer && drawer.getAttribute('data-section-id');
          const html = cart && cart.sections && sectionId ? cart.sections[sectionId] : '';
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { html, open: true } }));
        })
        .catch(() => {})
        .finally(() => {
          setAvailability(true);
        });
    };

    const applyColour = (name, hex, isOriginal) => {
      const coloursRoot = page.querySelector('[data-product-colours]');
      const colourInput = page.querySelector('[data-product-colour-property]');
      const colourLabel = page.querySelector('[data-product-colour-label]');
      const originalLabel = (coloursRoot && coloursRoot.getAttribute('data-original-label')) || name;
      if (colourInput) colourInput.value = name;
      if (colourLabel) colourLabel.textContent = isOriginal ? originalLabel : name;
      if (hex) {
        page.querySelectorAll('[data-product-colour-swatch]').forEach((swatch) => {
          swatch.style.backgroundColor = hex;
        });
      }
      page.querySelectorAll('[data-product-colour-studio-name]').forEach((node) => {
        node.textContent = name;
      });
      const colourProperty = (coloursRoot && coloursRoot.getAttribute('data-colour-property')) || '';
      page.querySelectorAll('[data-product-colour-zoom-summary]').forEach((node) => {
        node.textContent = colourProperty ? `${colourProperty} : ${name}` : name;
      });
      page.querySelectorAll('[data-product-colour-option]').forEach((button) => {
        const active = button.getAttribute('data-colour-name') === name;
        button.setAttribute('data-active', active ? 'true' : 'false');
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const colourReset = page.querySelector('[data-product-colour-reset]');
      if (colourReset) colourReset.disabled = Boolean(isOriginal);
      syncSampleLinks();
    };

    const lowestSizeCents = () => {
      const values = [...page.querySelectorAll('[data-product-size]')]
        .map((item) => Number(item.getAttribute('data-price-cents')))
        .filter((value) => Number.isFinite(value));
      if (!values.length) return null;
      return Math.min(...values);
    };

    const updatePricePrefix = (cents, custom) => {
      if (!pricePrefix) return;
      if (custom) {
        pricePrefix.hidden = true;
        return;
      }
      const lowest = lowestSizeCents();
      pricePrefix.hidden = lowest !== null && Number(cents) !== lowest;
    };

    const formatMoney = (cents) => {
      const value = Number(cents);
      if (!Number.isFinite(value)) return '';
      const amount = (value / 100).toFixed(2);
      const noDecimals = String(Math.round(value / 100));
      const open = String.fromCharCode(123, 123);
      const close = String.fromCharCode(125, 125);
      const format = page.getAttribute('data-money-format') || open + 'amount' + close;
      const token = (name) => new RegExp(open + '\\s*' + name + '\\s*' + close, 'g');
      const formatted = format
        .replace(token('amount_no_decimals_with_comma_separator'), noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(token('amount_with_comma_separator'), amount.replace('.', ','))
        .replace(token('amount_no_decimals_with_space_separator'), noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ' '))
        .replace(token('amount_with_space_separator'), amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' '))
        .replace(token('amount_no_decimals'), noDecimals)
        .replace(token('amount'), amount);
      if (value % 100 === 0) return formatted.replace(/([.,]00)(?!\d)/, '');
      return formatted;
    };

    const currentPriceLabel = () => {
      const node = page.querySelector('[data-product-price]');
      return node ? String(node.textContent || '').trim() : '';
    };

    const addLabelWithPrice = () => {
      const price = currentPriceLabel();
      if (price && addWithPrice) return addWithPrice.split('__PRICE__').join(price);
      return addLabel;
    };

    const setCtaLabels = (available) => {
      const addText = addLabelWithPrice();
      ctaLabels.forEach((node) => {
        if (!available) {
          node.textContent = soldLabel;
          return;
        }
        node.textContent = node.hasAttribute('data-product-cta-with-price') ? addText : addLabel;
      });
    };

    const clearCustomPrice = () => {
      if (customPriceInput) {
        customPriceInput.value = '';
        customPriceInput.disabled = true;
      }
      if (customPriceCentsInput) {
        customPriceCentsInput.value = '';
        customPriceCentsInput.disabled = true;
      }
      if (customSizeLine) {
        customSizeLine.value = '';
        customSizeLine.disabled = true;
      }
    };

    const priceSource = (name, fallback) => {
      const fromBox = customBox && customBox.getAttribute(name);
      if (fromBox != null && fromBox !== '') return Number(fromBox);
      return Number(page.getAttribute(name) || fallback || 0);
    };

    const sizeReferences = () => {
      const raw =
        (customBox && customBox.getAttribute('data-size-references')) ||
        page.getAttribute('data-size-references') ||
        '[]';
      try {
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed.filter((item) => item && Number(item.price) > 100 && Number(item.area) > 0);
      } catch (error) {
        return [];
      }
    };

    const closestSizeReference = (area) => {
      let reference = null;
      let bestGap = Infinity;
      sizeReferences().forEach((item) => {
        const itemArea = Number(item.area);
        const gap = Math.abs(itemArea - area);
        if (!reference || gap < bestGap || (gap === bestGap && itemArea < Number(reference.area))) {
          reference = item;
          bestGap = gap;
        }
      });
      return reference;
    };

    // Custom size prices are rounded to the nearest 5 € (500 cents).
    const roundToFive = (cents) => Math.max(500, Math.round(cents / 500) * 500);

    const customPriceCentsFromDimensions = (width, length) => {
      const area = Number(width) * Number(length);
      if (!(area > 0)) return null;
      const perSqm = priceSource('data-price-per-sqm-cents', 0);
      if (perSqm > 0) return roundToFive((perSqm * area) / 10000);
      const reference = closestSizeReference(area);
      if (!reference) return null;
      return roundToFive((Number(reference.price) * area) / Number(reference.area));
    };

    const paintPrice = (cents) => {
      if (!(cents > 0)) return;
      const formatted = formatMoney(cents);
      page.querySelectorAll('[data-product-price]').forEach((node) => {
        node.textContent = formatted;
      });
      if (customSizePrice) customSizePrice.textContent = formatted;
      if (customSizeTotal) customSizeTotal.hidden = false;
      updatePricePrefix(cents, true);
      setCtaLabels(!ctaButtons[0] || !ctaButtons[0].disabled);
    };

    const applyCustomPrice = () => {
      if (page.getAttribute('data-mode') !== 'custom') {
        clearCustomPrice();
        if (customSizeTotal) customSizeTotal.hidden = true;
        return;
      }
      const widthValue = widthInput && widthInput.value;
      const lengthValue = lengthInput && lengthInput.value;
      const cents = customPriceCentsFromDimensions(widthValue, lengthValue);
      if (cents > 0) paintPrice(cents);
      else if (customSizeTotal) customSizeTotal.hidden = true;

      const valid =
        cents > 0 &&
        !dimensionError(widthValue, 'width') &&
        !dimensionError(lengthValue, 'length');
      if (!valid) {
        clearCustomPrice();
        return;
      }
      const dollars = (cents / 100).toFixed(2);
      if (customPriceInput) {
        customPriceInput.disabled = false;
        customPriceInput.value = dollars;
      }
      if (customPriceCentsInput) {
        customPriceCentsInput.disabled = false;
        customPriceCentsInput.value = String(cents);
      }
      if (customSizeLine) {
        customSizeLine.disabled = false;
        customSizeLine.value = `${String(widthValue).trim()}x${String(lengthValue).trim()} cm`;
      }
    };

    const normalizeSize = (value) =>
      String(value || '')
        .toLowerCase()
        .replace(/[×✕]/g, 'x')
        .replace(/\s+/g, ' ')
        .trim();

    const setAvailability = (available) => {
      const canAdd = editingCartLine() ? true : available;
      ctaButtons.forEach((button) => {
        button.disabled = !canAdd;
      });
      setCtaLabels(canAdd);
    };

    const selectSize = (button) => {
      if (!button) return;
      page.querySelectorAll('[data-product-size]').forEach((item) => {
        const active = item === button;
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
        item.setAttribute('data-active', active ? 'true' : 'false');
      });
      const size = button.getAttribute('data-size') || '';
      const price = button.getAttribute('data-price') || '';
      const available = button.getAttribute('data-available') !== 'false';
      if (variantInput) variantInput.value = button.getAttribute('data-variant-id') || variantInput.value;
      if (sizeProperty) sizeProperty.value = size;
      priceNodes.forEach((node) => {
        node.textContent = price;
      });
      updatePricePrefix(button.getAttribute('data-price-cents'), false);
      sizeNotes.forEach((node) => {
        node.textContent = formatSizeNote(size);
      });
      page.querySelectorAll('[data-product-pick-size]').forEach((item) => {
        item.setAttribute(
          'aria-pressed',
          normalizeSize(item.getAttribute('data-product-pick-size')) === normalizeSize(size) ? 'true' : 'false'
        );
      });
      setAvailability(available);
      if (sizeError) sizeError.hidden = true;
      syncSampleLinks();
    };

    const dimensionError = (value, kind) => {
      const raw = String(value || '').trim();
      const required = (customBox && customBox.getAttribute('data-error-required')) || '';
      const minError = (customBox && customBox.getAttribute('data-error-min')) || '';
      const maxError = (customBox && customBox.getAttribute('data-error-max')) || '';
      const stepError = (customBox && customBox.getAttribute('data-error-step')) || '';
      const word = kind === 'width' ? widthWord : lengthWord;
      if (!raw) return required.replace('__DIM__', word);
      const number = Number(raw);
      if (!Number.isFinite(number) || number < customMin) {
        return minError.replace('__DIM__', word);
      }
      if (kind === 'width' && number > customMaxWidth) return maxError;
      if (number % customStep) {
        const low = Math.floor(number / customStep) * customStep;
        const high = Math.ceil(number / customStep) * customStep;
        return stepError.replace('__LOW__', String(low)).replace('__HIGH__', String(high));
      }
      return '';
    };

    const renderSuggestions = (input, container, kind) => {
      if (!container) return;
      container.replaceChildren();
      const number = Number(input && input.value);
      if (!input || !input.value || !Number.isFinite(number) || number % customStep === 0) {
        container.hidden = true;
        return;
      }
      const values = [Math.floor(number / customStep) * customStep, Math.ceil(number / customStep) * customStep]
        .filter((value, index, list) => {
          if (list.indexOf(value) !== index) return false;
          if (value < customMin) return false;
          if (kind === 'width' && value > customMaxWidth) return false;
          return true;
        });
      values.forEach((value) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('data-product-suggest', kind);
        button.setAttribute('data-product-suggest-value', String(value));
        button.textContent = `${value} ${unitLabel}`;
        container.appendChild(button);
      });
      container.hidden = values.length === 0;
    };

    const setFieldError = (input, node, message) => {
      if (node) {
        node.textContent = message || '';
        node.hidden = !message;
      }
      if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
    };

    const updateCustomizer = () => {
      if (page.getAttribute('data-mode') !== 'custom') return;
      const width = widthInput && widthInput.value;
      const length = lengthInput && lengthInput.value;
      const widthNumber = Number(width);
      const lengthNumber = Number(length);
      const size = width && length ? `${width} × ${length} ${unitLabel}` : '';
      sizeNotes.forEach((node) => {
        node.textContent = formatSizeNote(size);
      });
      if (proportionShape) {
        if (widthNumber > 0 && lengthNumber > 0) {
          proportionShape.style.aspectRatio = `${widthNumber} / ${lengthNumber}`;
        } else {
          proportionShape.style.aspectRatio = '2 / 3';
        }
      }
      if (proportionWidth) {
        proportionWidth.textContent = width ? `${width} ${unitLabel}` : `${emptyMark} ${unitLabel}`;
      }
      if (proportionLength) {
        proportionLength.textContent = length ? `${length} ${unitLabel}` : `${emptyMark} ${unitLabel}`;
      }
      if (proportionFigure) {
        const template = customBox && customBox.getAttribute('data-proportion-of');
        if (template && width && length) {
          proportionFigure.setAttribute('aria-label', template.replace('__W__', width).replace('__L__', length));
        }
      }
      const widthMessage = dimensionError(width, 'width');
      const lengthMessage = dimensionError(length, 'length');
      setFieldError(widthInput, widthError, width && widthMessage ? widthMessage : '');
      setFieldError(lengthInput, lengthError, length && lengthMessage ? lengthMessage : '');
      renderSuggestions(widthInput, widthSuggestions, 'width');
      renderSuggestions(lengthInput, lengthSuggestions, 'length');
      applyCustomPrice();
      if (editingCartLine()) setAvailability(true);
    };

    const stepDimension = (kind, delta) => {
      const input = kind === 'width' ? widthInput : lengthInput;
      if (!input) return;
      const current = Number(input.value);
      const base = Number.isFinite(current) ? current : customMin;
      let next = base % customStep === 0
        ? base + delta * customStep
        : delta > 0
          ? Math.ceil(base / customStep) * customStep
          : Math.floor(base / customStep) * customStep;
      next = Math.max(customMin, next);
      if (kind === 'width') next = Math.min(customMaxWidth, next);
      input.value = String(next);
      updateCustomizer();
    };

    const setMode = (mode) => {
      page.setAttribute('data-mode', mode);
      page.querySelectorAll('[data-product-mode]').forEach((button) => {
        const active = button.getAttribute('data-product-mode') === mode;
        button.setAttribute('data-active', active ? 'true' : 'false');
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const sizes = page.querySelector('[data-product-sizes]');
      if (sizes) sizes.hidden = mode === 'custom';
      if (customBox) customBox.hidden = mode !== 'custom';
      if (widthInput) widthInput.disabled = mode !== 'custom';
      if (lengthInput) lengthInput.disabled = mode !== 'custom';
      if (sizeProperty) sizeProperty.disabled = mode === 'custom';
      if (mode !== 'custom') clearCustomPrice();
      if (mode === 'custom') {
        const customId = page.getAttribute('data-custom-variant-id');
        if (variantInput && customId) variantInput.value = customId;
        const defaultWidth = Number((customBox && customBox.getAttribute('data-default-width')) || 0);
        const defaultLength = Number((customBox && customBox.getAttribute('data-default-length')) || 0);
        if (widthInput && !String(widthInput.value || '').trim() && defaultWidth > 0) {
          widthInput.value = String(defaultWidth);
        }
        if (lengthInput && !String(lengthInput.value || '').trim() && defaultLength > 0) {
          lengthInput.value = String(defaultLength);
        }
        updatePricePrefix(null, true);
        updateCustomizer();
        const title = customBox && customBox.querySelector('h2');
        if (title) title.focus({ preventScroll: true });
      } else {
        const active = page.querySelector('[data-product-size][data-active="true"]');
        if (active) selectSize(active);
      }
    };

    const openDialog = (selector) => {
      const dialog = selector ? page.querySelector(selector) : null;
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      const focusable = dialog.querySelector('[data-dialog-focus]');
      if (focusable) focusable.focus();
    };

    const closeDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      if (dialog === lightbox) resetZoom();
    };

    const activeLightboxImage = () => {
      const slide = [...slides].find((item) => !item.hidden);
      return slide ? slide.querySelector('img') : null;
    };

    const clampZoomOffset = () => {
      if (!lightboxStage || zoomScale <= 1) {
        zoomX = 0;
        zoomY = 0;
        return;
      }
      const bounds = lightboxStage.getBoundingClientRect();
      const maxX = ((bounds.width * (zoomScale - 1)) / 2) * 0.95;
      const maxY = ((bounds.height * (zoomScale - 1)) / 2) * 0.95;
      zoomX = Math.max(-maxX, Math.min(maxX, zoomX));
      zoomY = Math.max(-maxY, Math.min(maxY, zoomY));
    };

    const renderZoom = () => {
      const image = activeLightboxImage();
      if (image) {
        image.style.transform = `translate3d(${zoomX}px, ${zoomY}px, 0) scale(${zoomScale})`;
      }
      if (lightboxStage) {
        lightboxStage.setAttribute('data-zoomed', zoomScale > 1 ? 'true' : 'false');
      }
      if (zoomLabel) zoomLabel.textContent = `${Math.round(zoomScale * 100)}%`;
      if (zoomInButton) zoomInButton.disabled = zoomScale >= zoomMax;
      if (zoomOutButton) zoomOutButton.disabled = zoomScale <= zoomMin;
      if (zoomResetButton) zoomResetButton.disabled = zoomScale <= zoomMin && zoomX === 0 && zoomY === 0;
    };

    const resetZoom = () => {
      zoomScale = 1;
      zoomX = 0;
      zoomY = 0;
      dragPointerId = null;
      didDrag = false;
      if (lightboxStage) lightboxStage.removeAttribute('data-dragging');
      slides.forEach((slide) => {
        const image = slide.querySelector('img');
        if (image) image.style.transform = '';
      });
      renderZoom();
    };

    const setZoomAt = (nextScale, clientX, clientY) => {
      if (!lightboxStage) return;
      const previous = zoomScale;
      const scale = Math.max(zoomMin, Math.min(zoomMax, nextScale));
      if (scale === previous && scale === zoomMin) {
        resetZoom();
        return;
      }
      const bounds = lightboxStage.getBoundingClientRect();
      const pointX = (clientX == null ? bounds.left + bounds.width / 2 : clientX) - bounds.left - bounds.width / 2;
      const pointY = (clientY == null ? bounds.top + bounds.height / 2 : clientY) - bounds.top - bounds.height / 2;
      const ratio = scale / previous;
      zoomX = pointX - (pointX - zoomX) * ratio;
      zoomY = pointY - (pointY - zoomY) * ratio;
      zoomScale = scale;
      if (zoomScale <= zoomMin) {
        resetZoom();
        return;
      }
      clampZoomOffset();
      renderZoom();
    };

    const showSlide = (index) => {
      if (!slides.length) return;
      lightboxIndex = (index + slides.length) % slides.length;
      slides.forEach((slide) => {
        slide.hidden = Number(slide.getAttribute('data-product-lightbox-slide')) !== lightboxIndex;
      });
      const current = String(lightboxIndex + 1).padStart(2, '0');
      const total = String(slides.length).padStart(2, '0');
      if (lightboxCount) lightboxCount.textContent = `${current} / ${total}`;
      const openers = page.querySelectorAll('[data-product-lightbox-open]');
      const opener = openers[Math.min(lightboxIndex, openers.length - 1)];
      if (lightboxCaption && opener) {
        const figure = opener.closest('figure');
        const caption = figure ? figure.querySelector('figcaption') : null;
        lightboxCaption.textContent = caption ? caption.textContent : '';
      }
      resetZoom();
      watchLightboxImage();
    };

    const setLightboxLoading = (isLoading) => {
      if (lightboxStage) {
        if (isLoading) lightboxStage.setAttribute('data-loading', 'true');
        else lightboxStage.removeAttribute('data-loading');
      }
      if (lightboxSpinner) lightboxSpinner.hidden = !isLoading;
    };

    const watchLightboxImage = () => {
      const token = ++lightboxLoadToken;
      let image = null;
      slides.forEach((slide) => {
        if (Number(slide.getAttribute('data-product-lightbox-slide')) === lightboxIndex) {
          image = slide.querySelector('img');
        }
      });
      const finish = () => {
        if (token !== lightboxLoadToken) return;
        setLightboxLoading(false);
      };
      if (!image) {
        finish();
        return;
      }
      if (image.getAttribute('loading') === 'lazy') image.loading = 'eager';
      if (image.complete && image.naturalWidth > 0) {
        finish();
        return;
      }
      setLightboxLoading(true);
      const onReady = () => {
        image.removeEventListener('load', onReady);
        image.removeEventListener('error', onReady);
        finish();
      };
      image.addEventListener('load', onReady);
      image.addEventListener('error', onReady);
      if (typeof image.decode === 'function') {
        image.decode().then(onReady).catch(onReady);
      }
    };

    renderZoom();

    page.addEventListener('click', (event) => {
      const sizeButton = event.target.closest('[data-product-size]');
      if (sizeButton && page.contains(sizeButton)) {
        selectSize(sizeButton);
        return;
      }

      const modeButton = event.target.closest('[data-product-mode]');
      if (modeButton) {
        setMode(modeButton.getAttribute('data-product-mode'));
        return;
      }

      const stepButton = event.target.closest('[data-product-step]');
      if (stepButton && customBox && customBox.contains(stepButton)) {
        stepDimension(
          stepButton.getAttribute('data-product-step'),
          Number(stepButton.getAttribute('data-product-step-delta')) || 0
        );
        return;
      }

      const suggestButton = event.target.closest('[data-product-suggest]');
      if (suggestButton && customBox && customBox.contains(suggestButton)) {
        const kind = suggestButton.getAttribute('data-product-suggest');
        const input = kind === 'width' ? widthInput : lengthInput;
        if (input) input.value = suggestButton.getAttribute('data-product-suggest-value') || '';
        updateCustomizer();
        return;
      }

      const opener = event.target.closest('[data-product-dialog-open]');
      if (opener) {
        openDialog(opener.getAttribute('data-product-dialog-open'));
        return;
      }

      const closer = event.target.closest('[data-product-dialog-close]');
      if (closer) {
        closeDialog(closer.closest('dialog'));
        return;
      }

      const guideTab = event.target.closest('[data-product-guide-tab]');
      if (guideTab) {
        const dialog = guideTab.closest('dialog');
        const index = guideTab.getAttribute('data-product-guide-tab');
        dialog.querySelectorAll('[data-product-guide-tab]').forEach((tab) => {
          tab.setAttribute('aria-pressed', tab === guideTab ? 'true' : 'false');
        });
        dialog.querySelectorAll('[data-product-guide-panel]').forEach((panel) => {
          panel.setAttribute(
            'data-active',
            panel.getAttribute('data-product-guide-panel') === index ? 'true' : 'false'
          );
        });
        const grid = dialog.querySelector('[data-product-guide-grid]');
        if (grid) grid.setAttribute('data-scene', index);
        return;
      }

      const colourOption = event.target.closest('[data-product-colour-option]');
      if (colourOption) {
        const coloursRoot = page.querySelector('[data-product-colours]');
        if (coloursRoot && coloursRoot.hasAttribute('data-profile-picker')) return;
        applyColour(
          colourOption.getAttribute('data-colour-name') || '',
          colourOption.getAttribute('data-colour-hex') || '',
          colourOption.getAttribute('data-colour-original') === 'true'
        );
        return;
      }

      const colourReset = event.target.closest('[data-product-colour-reset]');
      if (colourReset) {
        const coloursRoot = page.querySelector('[data-product-colours]');
        if (coloursRoot && coloursRoot.hasAttribute('data-profile-picker')) return;
        if (coloursRoot) {
          applyColour(
            coloursRoot.getAttribute('data-original-name') || '',
            coloursRoot.getAttribute('data-original-hex') || '',
            true
          );
        }
        return;
      }

      const pileOption = event.target.closest('[data-product-pile-option]');
      if (pileOption) {
        applyPile(pileOption.getAttribute('data-pile-value') || '');
        if (pileOption.hasAttribute('data-product-pile-apply')) {
          closeDialog(pileOption.closest('dialog'));
        }
        return;
      }

      if (event.target.closest('[data-fringe-option]') && editingCartLine()) {
        setAvailability(true);
      }

      const customGuide = event.target.closest('[data-product-guide-custom]');
      if (customGuide) {
        closeDialog(customGuide.closest('dialog'));
        setMode('custom');
        return;
      }

      const pick = event.target.closest('[data-product-pick-size]');
      if (pick) {
        const size = pick.getAttribute('data-product-pick-size');
        let match = null;
        page.querySelectorAll('[data-product-size]').forEach((item) => {
          if (normalizeSize(item.getAttribute('data-size')) === normalizeSize(size)) match = item;
        });
        if (match) selectSize(match);
        else if (sizeProperty) {
          sizeProperty.value = size;
          sizeNotes.forEach((node) => {
            node.textContent = formatSizeNote(size);
          });
        }
        setMode('standard');
        closeDialog(pick.closest('dialog'));
        return;
      }

      if (event.target.closest('[data-product-lightbox-zoom-in]')) {
        setZoomAt(zoomScale + zoomStep);
        return;
      }
      if (event.target.closest('[data-product-lightbox-zoom-out]')) {
        setZoomAt(zoomScale - zoomStep);
        return;
      }
      if (event.target.closest('[data-product-lightbox-zoom-reset]')) {
        resetZoom();
        return;
      }

      const lightOpener = event.target.closest('[data-product-lightbox-open]');
      if (lightOpener) {
        showSlide(Number(lightOpener.getAttribute('data-product-lightbox-open')) || 0);
        if (lightbox) {
          if (typeof lightbox.showModal === 'function') lightbox.showModal();
          else lightbox.setAttribute('open', '');
          const focusable = lightbox.querySelector('[data-dialog-focus]');
          if (focusable) focusable.focus();
        }
        return;
      }

      if (event.target.closest('[data-product-lightbox-prev]')) {
        showSlide(lightboxIndex - 1);
        return;
      }
      if (event.target.closest('[data-product-lightbox-next]')) {
        showSlide(lightboxIndex + 1);
      }
    });

    if (lightboxStage) {
      lightboxStage.addEventListener(
        'wheel',
        (event) => {
          if (!lightbox || !lightbox.open) return;
          event.preventDefault();
          const delta = event.deltaY > 0 ? -zoomStep : zoomStep;
          setZoomAt(zoomScale + delta, event.clientX, event.clientY);
        },
        { passive: false }
      );

      lightboxStage.addEventListener('pointerdown', (event) => {
        if (event.target.closest('.product-lightbox__zoom')) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.pointerType === 'touch' && event.isPrimary === false) return;
        didDrag = false;
        dragPointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartY = event.clientY;
        dragOriginX = zoomX;
        dragOriginY = zoomY;
        lightboxStage.setPointerCapture(event.pointerId);
      });

      lightboxStage.addEventListener('pointermove', (event) => {
        if (dragPointerId !== event.pointerId) return;
        const dx = event.clientX - dragStartX;
        const dy = event.clientY - dragStartY;
        if (!didDrag && Math.hypot(dx, dy) < 4) return;
        didDrag = true;
        if (zoomScale <= 1) return;
        lightboxStage.setAttribute('data-dragging', 'true');
        zoomX = dragOriginX + dx;
        zoomY = dragOriginY + dy;
        clampZoomOffset();
        renderZoom();
      });

      const endPointer = (event) => {
        if (dragPointerId !== event.pointerId) return;
        const wasDrag = didDrag;
        dragPointerId = null;
        lightboxStage.removeAttribute('data-dragging');
        if (lightboxStage.hasPointerCapture(event.pointerId)) {
          lightboxStage.releasePointerCapture(event.pointerId);
        }
        if (wasDrag) return;
        if (event.target.closest('.product-lightbox__zoom')) return;
        if (zoomScale > 1) setZoomAt(1, event.clientX, event.clientY);
        else setZoomAt(2.25, event.clientX, event.clientY);
      };

      lightboxStage.addEventListener('pointerup', endPointer);
      lightboxStage.addEventListener('pointercancel', endPointer);

      lightboxStage.addEventListener(
        'touchstart',
        (event) => {
          if (event.touches.length === 2) {
            const [a, b] = event.touches;
            pinchStartDistance = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
            pinchStartScale = zoomScale;
            dragPointerId = null;
          }
        },
        { passive: true }
      );

      lightboxStage.addEventListener(
        'touchmove',
        (event) => {
          if (event.touches.length !== 2 || !pinchStartDistance) return;
          event.preventDefault();
          const [a, b] = event.touches;
          const distance = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
          const midX = (a.clientX + b.clientX) / 2;
          const midY = (a.clientY + b.clientY) / 2;
          setZoomAt(pinchStartScale * (distance / pinchStartDistance), midX, midY);
        },
        { passive: false }
      );

      lightboxStage.addEventListener(
        'touchend',
        (event) => {
          if (event.touches.length < 2) pinchStartDistance = 0;
        },
        { passive: true }
      );
    }

    if (lightbox) {
      lightbox.addEventListener('close', resetZoom);
    }

    page.querySelectorAll('dialog').forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog(dialog);
      });
    });

    if (gallery && dots.length) {
      gallery.addEventListener('scroll', () => {
        const index = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
        dots.forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      });
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.getAttribute('data-product-page-dot')) || 0;
          gallery.scrollTo({ left: gallery.clientWidth * index, behavior: 'smooth' });
        });
      });
    }

    const updateCustomNote = () => {
      updateCustomizer();
    };
    if (widthInput) widthInput.addEventListener('input', updateCustomNote);
    if (lengthInput) lengthInput.addEventListener('input', updateCustomNote);
    if (widthInput) widthInput.addEventListener('change', updateCustomNote);
    if (lengthInput) lengthInput.addEventListener('change', updateCustomNote);

    if (form) {
      form.addEventListener('submit', (event) => {
        const mode = page.getAttribute('data-mode');
        if (mode === 'custom') {
          const widthMessage = dimensionError(widthInput && widthInput.value, 'width');
          const lengthMessage = dimensionError(lengthInput && lengthInput.value, 'length');
          setFieldError(widthInput, widthError, widthMessage);
          setFieldError(lengthInput, lengthError, lengthMessage);
          if (widthMessage || lengthMessage) {
            event.preventDefault();
            if (sizeError) sizeError.hidden = false;
            return;
          }
        } else {
          const active = page.querySelector('[data-product-size][data-active="true"]');
          if (!active && page.querySelector('[data-product-size]')) {
            event.preventDefault();
            if (sizeError) sizeError.hidden = false;
            return;
          }
        }
        const lineKey = new URLSearchParams(window.location.search).get('line');
        if (!lineKey) return;
        const colourCard = page.querySelector('[data-product-colours][data-profile-picker]');
        if (
          colourCard &&
          colourCard.getAttribute('data-require') === 'true' &&
          colourCard.getAttribute('data-chosen') !== 'true'
        ) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        replaceCartLine(lineKey);
      });
    }

    if (mobileBar && cta && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.some((entry) => entry.isIntersecting);
        mobileBar.setAttribute('data-visible', visible ? 'false' : 'true');
        mobileBar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      }, { threshold: 0.4 });
      observer.observe(cta);
    }

    const incoming = new URLSearchParams(window.location.search);
    const incomingSize =
      incoming.get('size') || incoming.get('dimensions') || incoming.get('taille') || '';
    const incomingWidth = incoming.get('width') || '';
    const incomingLength = incoming.get('length') || '';
    const editingCustom = incoming.get('custom') === '1';
    const sizeFromText = parseDimensions(incomingSize);
    const customWidth = incomingWidth || (editingCustom && sizeFromText ? sizeFromText.width : '');
    const customLength = incomingLength || (editingCustom && sizeFromText ? sizeFromText.length : '');

    if (!editingCustom) {
      const activeSize = page.querySelector('[data-product-size][data-active="true"]');
      if (activeSize) selectSize(activeSize);
    }

    const sizeKey = (value) =>
      normalizeSize(value)
        .replace(/\s*cm\b/g, '')
        .replace(/\s+/g, '')
        .trim();

    if (customWidth && customLength && widthInput && lengthInput) {
      widthInput.value = String(customWidth).replace(',', '.').replace(/[^\d.]/g, '');
      lengthInput.value = String(customLength).replace(',', '.').replace(/[^\d.]/g, '');
      setMode('custom');
    } else if (incomingSize) {
      let match = null;
      page.querySelectorAll('[data-product-size]').forEach((item) => {
        if (sizeKey(item.getAttribute('data-size')) === sizeKey(incomingSize)) match = item;
      });
      if (!match && incoming.get('variant')) {
        page.querySelectorAll('[data-product-size]').forEach((item) => {
          if (item.getAttribute('data-variant-id') === incoming.get('variant')) match = item;
        });
      }
      if (match) selectSize(match);
    }
    const incomingPile = incoming.get('pile') || incoming.get('velours') || incoming.get('hauteur') || '';
    if (incomingPile) applyPile(incomingPile);
    applyFringes(incoming.get('fringes') || '');
    syncSampleLinks();
    if (incoming.get('line')) setAvailability(true);

    showSlide(0);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["professional-account"] && !Shopify.designMode) return;
  try {
    
  function initProfessionalAccount() {
    const root = document.querySelector('[data-professional-account]');
    if (!root || root.getAttribute('data-customer') === 'true') return;

    const storageKey = root.getAttribute('data-storage-key') || 'db-trade-account-demo-v1';
    const loading = root.querySelector('[data-account-loading]');
    const guest = root.querySelector('[data-account-guest]');
    const session = root.querySelector('[data-account-session]');
    const context = root.querySelector('[data-account-context]');
    const errorNode = root.querySelector('[data-account-error]');
    const nameNode = root.querySelector('[data-account-name]');
    const companyNode = root.querySelector('[data-account-company]');
    const catalogNode = root.querySelector('[data-account-catalog]');
    const otherChoices = root.querySelector('[data-account-other-choices]');
    const signInButtons = Array.from(root.querySelectorAll('[data-account-sign-in]'));
    const signOutButton = root.querySelector('[data-account-sign-out]');
    const profiles = {};

    signInButtons.forEach((button) => {
      const id = button.getAttribute('data-profile-id');
      if (!id) return;
      profiles[id] = {
        id: id,
        name: button.getAttribute('data-name') || '',
        company: button.getAttribute('data-company') || '',
        activity: button.getAttribute('data-activity') || '',
        catalog: button.getAttribute('data-catalog') || '',
      };
    });

    const setError = (message) => {
      if (!errorNode) return;
      if (message) {
        errorNode.textContent = message;
        errorNode.hidden = false;
      } else {
        errorNode.textContent = '';
        errorNode.hidden = true;
      }
    };

    const readProfileId = () => {
      try {
        const value = sessionStorage.getItem(storageKey);
        return value && profiles[value] ? value : null;
      } catch (error) {
        return null;
      }
    };

    const writeProfileId = (id) => {
      try {
        if (id) sessionStorage.setItem(storageKey, id);
        else sessionStorage.removeItem(storageKey);
        return true;
      } catch (error) {
        return false;
      }
    };

    const renderOtherChoices = (activeId) => {
      if (!otherChoices) return;
      otherChoices.replaceChildren();
      Object.keys(profiles).forEach((id) => {
        if (id === activeId) return;
        const profile = profiles[id];
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'professional-account__choice';
        button.textContent = 'Utiliser ' + profile.company;
        button.addEventListener('click', () => signIn(id));
        otherChoices.appendChild(button);
      });
    };

    const showSession = (profile) => {
      if (nameNode) nameNode.textContent = profile.name;
      if (companyNode) companyNode.textContent = profile.company;
      if (catalogNode) catalogNode.textContent = profile.catalog;
      renderOtherChoices(profile.id);
      if (guest) guest.hidden = true;
      if (session) session.hidden = false;
      if (loading) loading.hidden = true;
    };

    const showGuest = () => {
      if (guest) guest.hidden = false;
      if (session) session.hidden = true;
      if (loading) loading.hidden = true;
    };

    const signIn = (id) => {
      const profile = profiles[id];
      if (!profile) return;
      if (!writeProfileId(id)) {
        setError(
          'La connexion de démonstration n’a pas pu être conservée. Vérifiez que votre navigateur autorise le stockage des données du site, puis réessayez.'
        );
        return;
      }
      setError('');
      showSession(profile);
    };

    const signOut = () => {
      if (!writeProfileId(null)) {
        setError('La déconnexion n’a pas abouti. Réessayez ; le compte de démonstration reste actif.');
        return;
      }
      setError('');
      showGuest();
    };

    signInButtons.forEach((button) => {
      button.addEventListener('click', () => {
        signIn(button.getAttribute('data-profile-id'));
      });
    });

    if (signOutButton) signOutButton.addEventListener('click', signOut);

    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get('return') && context) context.hidden = false;
    } catch (error) {
      // Ignore malformed search params.
    }

    const activeId = readProfileId();
    if (activeId) showSession(profiles[activeId]);
    else showGuest();
  }

  initProfessionalAccount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["professional-project"] && !Shopify.designMode) return;
  try {
    
  function initProfessionalProject() {
    const roots = document.querySelectorAll('[data-professional-project]');
    const acceptedTypes = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];

    roots.forEach((root) => {
      const form = root.querySelector('.professional-project__form');
      if (!form) return;

      const radios = form.querySelectorAll('[data-need]');
      const message = form.querySelector('[data-project-message]');
      const subject = form.querySelector('[data-project-subject]');
      const upload = form.querySelector('[data-project-upload]');
      const picker = form.querySelector('[data-project-file-picker]');
      const fileInput = form.querySelector('[data-project-file-input]');
      const namesInput = form.querySelector('[data-project-file-names]');
      const trigger = form.querySelector('[data-project-file-trigger]');
      const list = form.querySelector('[data-project-attachments]');
      const errorNode = form.querySelector('[data-project-upload-error]');
      const fileIcon = form.querySelector('[data-project-file-icon]');
      const removeIcon = form.querySelector('[data-project-remove-icon]');
      let files = [];

      const applyNeed = () => {
        const selected = form.querySelector('[data-need]:checked');
        const need = selected ? selected.getAttribute('data-need') : 'access';

        if (message) {
          const placeholder = message.getAttribute('data-placeholder-' + need);
          if (placeholder) message.setAttribute('placeholder', placeholder);
          if (need === 'advice') message.setAttribute('required', 'required');
          else message.removeAttribute('required');
        }

        if (subject) {
          const nextSubject = subject.getAttribute('data-subject-' + need);
          if (nextSubject) subject.value = nextSubject;
        }
      };

      const validateFiles = (nextFiles) => {
        if (!upload) return '';
        const maxFiles = Number(upload.getAttribute('data-max-files') || 3);
        const maxBytes = Number(upload.getAttribute('data-max-bytes') || 2097152);
        if (nextFiles.length > maxFiles) return upload.getAttribute('data-error-count') || '';
        if (nextFiles.some((file) => !acceptedTypes.includes(file.type))) {
          return upload.getAttribute('data-error-type') || '';
        }
        if (nextFiles.some((file) => !Number.isFinite(file.size) || file.size <= 0)) {
          return upload.getAttribute('data-error-empty') || '';
        }
        const total = nextFiles.reduce((sum, file) => sum + file.size, 0);
        if (total > maxBytes) return upload.getAttribute('data-error-size') || '';
        return '';
      };

      const syncInputs = () => {
        if (fileInput && typeof DataTransfer !== 'undefined') {
          const transfer = new DataTransfer();
          if (files[0]) transfer.items.add(files[0]);
          fileInput.files = transfer.files;
        }
        if (namesInput) {
          namesInput.value = files.map((file) => file.name).join(', ');
        }
      };

      const setError = (messageText) => {
        if (!errorNode) return;
        if (messageText) {
          errorNode.textContent = messageText;
          errorNode.hidden = false;
        } else {
          errorNode.textContent = '';
          errorNode.hidden = true;
        }
      };

      const renderFiles = () => {
        if (!list) return;
        list.replaceChildren();
        list.hidden = files.length === 0;
        syncInputs();

        files.forEach((file, index) => {
          const item = document.createElement('li');
          if (file.type.startsWith('image/')) {
            const image = document.createElement('img');
            image.src = URL.createObjectURL(file);
            image.alt = file.name;
            image.width = 48;
            image.height = 48;
            item.appendChild(image);
          } else if (fileIcon) {
            const icon = fileIcon.firstElementChild
              ? fileIcon.firstElementChild.cloneNode(true)
              : null;
            if (icon) item.appendChild(icon);
          }

          const link = document.createElement('a');
          link.href = URL.createObjectURL(file);
          link.download = file.name;
          link.textContent = file.name;
          const meta = document.createElement('small');
          const downloadLabel = upload
            ? upload.getAttribute('data-download-label') || 'Download'
            : 'Download';
          meta.textContent = Math.ceil(file.size / 1024) + ' Ko · ' + downloadLabel;
          link.appendChild(meta);
          item.appendChild(link);

          const remove = document.createElement('button');
          remove.type = 'button';
          const removeLabel = upload
            ? upload.getAttribute('data-remove-label') || 'Remove'
            : 'Remove';
          remove.setAttribute('aria-label', removeLabel + ' ' + file.name);
          if (removeIcon && removeIcon.firstElementChild) {
            remove.appendChild(removeIcon.firstElementChild.cloneNode(true));
          } else {
            remove.textContent = '×';
          }
          remove.addEventListener('click', () => {
            files = files.filter((_, fileIndex) => fileIndex !== index);
            setError('');
            renderFiles();
          });
          item.appendChild(remove);
          list.appendChild(item);
        });
      };

      if (trigger && picker) {
        trigger.addEventListener('click', () => picker.click());
      }

      if (picker) {
        picker.addEventListener('change', () => {
          const selected = Array.from(picker.files || []);
          picker.value = '';
          if (!selected.length) return;
          const nextFiles = files.concat(selected);
          const error = validateFiles(nextFiles);
          if (error) {
            setError(error);
            return;
          }
          setError('');
          files = nextFiles;
          renderFiles();
        });
      }

      radios.forEach((radio) => {
        radio.addEventListener('change', applyNeed);
      });

      applyNeed();
    });

    const success = document.querySelector('[data-project-success]');
    if (success) {
      const section = success.closest('[data-professional-project]');
      if (section) section.scrollIntoView({ block: 'start' });
    }
  }

  initProfessionalProject();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-product-recommendations][data-url]');
    if (!roots.length) return;

    const load = (root) => {
      const url = root.getAttribute('data-url');
      if (!url || root.getAttribute('data-loaded') === 'true') return;
      root.setAttribute('data-loaded', 'true');
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const next = document.createElement('div');
          next.innerHTML = text;
          const incoming = next.querySelector('[data-product-recommendations]');
          if (incoming && incoming.innerHTML.trim().length) {
            root.innerHTML = incoming.innerHTML;
          }
        })
        .catch(() => {});
    };

    roots.forEach((root) => {
      if (!('IntersectionObserver' in window)) {
        load(root);
        return;
      }
      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          load(root);
        },
        { rootMargin: '0px 0px 200px 0px' }
      );
      observer.observe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const boundAttr = 'data-reviews-bound';

    const readConfig = (root) => {
      const node = root.querySelector('[data-reviews-config]');
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    };

    const withCount = (template, count) => {
      const value = String(template || '');
      if (value.includes('[count]')) return value.replaceAll('[count]', String(count));
      return value.replace(/\d+/, String(count));
    };

    const displayName = (name) => {
      const parts = String(name || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      if (parts.length === 0) return '';
      if (parts.length === 1) return parts[0];
      return parts[0] + ' ' + parts[parts.length - 1].charAt(0).toUpperCase() + '.';
    };

    const parseDate = (value) => {
      if (value == null || value === '') return null;
      if (typeof value === 'string' && Number.isNaN(Number(value))) {
        const parsed = new Date(value);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
      }
      const number = Number(value);
      if (!Number.isFinite(number)) return null;
      if (number > 20000 && number < 80000) {
        return new Date((number - 25569) * 86400 * 1000);
      }
      const parsed = new Date(number);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    const formatDate = (value, locale) => {
      const date = parseDate(value);
      if (!date) return '';
      try {
        return new Intl.DateTimeFormat(locale || undefined, {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          timeZone: 'UTC',
        }).format(date);
      } catch (error) {
        return date.toISOString().slice(0, 10);
      }
    };

    const formatRating = (value, locale) => {
      try {
        return new Intl.NumberFormat(locale || undefined, {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        }).format(value);
      } catch (error) {
        return value.toFixed(1);
      }
    };

    const photosOf = (review) => {
      const raw = review && review.photos;
      if (Array.isArray(raw)) return raw.filter(Boolean);
      if (typeof raw === 'string') {
        return raw
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean);
      }
      return [];
    };

    const isApproved = (review) => !review.state || review.state === 'approved';

    const isVerified = (review) => review.verified === true || review.verified === 'true';

    const clearPortaledDialogs = (root, cardPhotos) => {
      const sectionId = root.getAttribute('data-section-id') || 'reviews';
      const prefix = 'ReviewPhotoDialog-' + sectionId + '-';
      document.querySelectorAll('body > dialog.reviews-dialog').forEach((dialog) => {
        if (!dialog.id || dialog.id.indexOf(prefix) !== 0) return;
        const suffix = dialog.id.slice(prefix.length);
        const isCard = suffix.charAt(0) === 'c';
        if (cardPhotos !== isCard) return;
        if (dialog.open && typeof dialog.close === 'function') dialog.close();
        dialog.remove();
      });
    };

    const setReviewLoading = (dialog, isLoading) => {
      const photo = dialog.querySelector('.reviews-dialog__photo');
      const spinner = dialog.querySelector('[data-review-photo-spinner]');
      if (photo) {
        if (isLoading) photo.setAttribute('data-loading', 'true');
        else photo.removeAttribute('data-loading');
      }
      if (spinner) spinner.hidden = !isLoading;
    };

    const revealDialogImage = (dialog) => {
      const image = dialog.querySelector('[data-review-photo-full], .reviews-dialog__photo img');
      const token = String(Date.now()) + Math.random();
      dialog.dataset.reviewLoadToken = token;
      const finish = () => {
        if (dialog.dataset.reviewLoadToken !== token) return;
        setReviewLoading(dialog, false);
      };
      if (!image) {
        finish();
        return;
      }
      const source = image.currentSrc || image.getAttribute('src');
      if (!source) {
        finish();
        return;
      }
      image.loading = 'eager';
      if (image.complete && image.naturalWidth === 0) {
        image.removeAttribute('src');
        image.src = source;
      }
      if (image.complete && image.naturalWidth > 0) {
        finish();
        return;
      }
      setReviewLoading(dialog, true);
      const onReady = () => {
        image.removeEventListener('load', onReady);
        image.removeEventListener('error', onReady);
        finish();
      };
      image.addEventListener('load', onReady);
      image.addEventListener('error', onReady);
      if (typeof image.decode === 'function') {
        image.decode().then(onReady).catch(onReady);
      }
    };

    const openDialog = (selector) => {
      if (!selector) return;
      const dialog = document.querySelector(selector);
      if (!dialog) return;
      if (dialog.parentElement !== document.body) {
        document.body.appendChild(dialog);
      }
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      revealDialogImage(dialog);
      dialog.scrollTop = 0;
    };

    const closeDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    const hideOverflowButtons = (root) => {
      root.querySelectorAll('[data-review-text]').forEach((text) => {
        if (text.hidden) return;
        const card = text.closest('.reviews-card');
        if (!card) return;
        const button = card.querySelector('[data-review-more]');
        if (!button || button.hidden) return;
        if (text.scrollHeight <= text.clientHeight + 2) {
          button.hidden = true;
        }
      });
    };

    const fillTemplate = (root, selector) => {
      const template = root.querySelector(selector);
      return template ? template.content.cloneNode(true) : null;
    };

    const createStars = (root, rating, label) => {
      const wrap = document.createElement('span');
      wrap.className = 'reviews-stars';
      wrap.setAttribute('role', 'img');
      wrap.setAttribute('aria-label', label);
      for (let i = 1; i <= 5; i += 1) {
        const star = fillTemplate(root, '[data-review-star-template]');
        if (!star) continue;
        const node = star.querySelector('.reviews-star');
        if (!node) continue;
        if (i > rating) node.classList.add('reviews-star--empty');
        wrap.appendChild(node);
      }
      return wrap;
    };

    const createCard = (root, review, index, expanded, config) => {
      const fragment = fillTemplate(root, '[data-review-card-template]');
      if (!fragment) return null;
      const card = fragment.querySelector('.reviews-card');
      if (!card) return null;

      const rating = Math.min(5, Math.max(1, Number(review.rating) || 5));
      const starLabel = String(config.starLabel || '').replaceAll('__RATING__', String(rating));
      const starsHost = card.querySelector('[data-review-stars]');
      if (starsHost) starsHost.replaceWith(createStars(root, rating, starLabel));

      const dateLabel = formatDate(review.created_at, config.locale);
      const dateNode = card.querySelector('[data-review-date]');
      if (dateNode && dateLabel) {
        dateNode.hidden = false;
        const parsedDate = parseDate(review.created_at);
        dateNode.dateTime = parsedDate ? parsedDate.toISOString() : '';
        dateNode.textContent = dateLabel;
      }

      const heading = String(review.heading || '').trim();
      const headingNode = card.querySelector('[data-review-heading]');
      if (headingNode && heading) {
        headingNode.hidden = false;
        headingNode.textContent = heading;
      }

      const body = String(review.body || '').trim();
      const textNode = card.querySelector('[data-review-text]');
      const moreNode = card.querySelector('[data-review-more]');
      const emptyNode = card.querySelector('[data-review-empty]');
      if (textNode && body) {
        const uid = root.getAttribute('data-section-id') || 'reviews';
        const textId = 'ReviewText-' + uid + '-' + index;
        textNode.hidden = false;
        textNode.id = textId;
        textNode.textContent = body;
        if (moreNode) {
          moreNode.hidden = false;
          moreNode.setAttribute('aria-controls', textId);
          moreNode.dataset.labelMore = config.readMore || '';
          moreNode.dataset.labelLess = config.readLess || '';
          moreNode.textContent = config.readMore || '';
        }
      } else if (emptyNode && !heading) {
        emptyNode.hidden = false;
        emptyNode.textContent = config.noText || '';
      }

      if (expanded) {
        const photosHost = card.querySelector('[data-review-card-photos]');
        const photos = photosOf(review);
        if (photosHost && photos.length) {
          photosHost.hidden = false;
          photos.forEach((url, photoIndex) => {
            const node = createPhoto(
              root,
              photoFromReview(review, url),
              'c' + index + '-' + photoIndex,
              config
            );
            if (node) photosHost.appendChild(node);
          });
        }
      }

      const authorNode = card.querySelector('[data-review-author]');
      if (authorNode) authorNode.textContent = displayName(review.author || review.customer_name);

      const verifiedNode = card.querySelector('[data-review-verified]');
      if (verifiedNode && isVerified(review)) {
        verifiedNode.hidden = false;
        const verifiedLabel = verifiedNode.querySelector('[data-review-verified-label]');
        if (verifiedLabel) verifiedLabel.textContent = config.verifiedLabel || '';
      }

      return card;
    };

    const photoFromReview = (review, url) => ({
      url,
      author: review.author || review.customer_name || '',
      created_at: review.created_at,
      rating: review.rating,
      heading: review.heading,
      body: review.body,
      verified: review.verified,
    });

    const createPhoto = (root, photo, index, config) => {
      const fragment = fillTemplate(root, '[data-review-photo-template]');
      if (!fragment) return null;
      const wrap = fragment.querySelector('.reviews-photo');
      const dialog = fragment.querySelector('dialog');
      if (!wrap || !dialog) return null;

      const dialogId = 'ReviewPhotoDialog-' + (root.getAttribute('data-section-id') || 'reviews') + '-' + index;
      const titleId = dialogId + '-title';
      const author = displayName(photo.author);
      const label = author
        ? String(config.viewPhoto || '').replaceAll('__AUTHOR__', author)
        : config.viewPhotoUntitled || '';
      const title = author
        ? String(config.photoOf || '').replaceAll('__AUTHOR__', author)
        : config.viewPhotoUntitled || '';
      const alt = author
        ? String(config.photoAlt || label).replaceAll('__AUTHOR__', author)
        : label;

      dialog.id = dialogId;
      dialog.setAttribute('aria-labelledby', titleId);
      const close = dialog.querySelector('[data-review-close]');
      if (close) close.setAttribute('aria-label', config.closeLabel || '');
      const heading = dialog.querySelector('[data-review-photo-author]');
      if (heading) {
        heading.id = titleId;
        heading.textContent = title;
      }

      const dateLabel = formatDate(photo.created_at, config.locale);
      const dateNode = dialog.querySelector('[data-review-photo-date]');
      if (dateNode && dateLabel) {
        dateNode.hidden = false;
        dateNode.textContent = String(config.photoDate || '').replaceAll('__DATE__', dateLabel);
      }

      const rating = Math.min(5, Math.max(0, Number(photo.rating) || 0));
      const starsHost = dialog.querySelector('[data-review-photo-stars]');
      if (starsHost && rating >= 1) {
        const starLabel = String(config.starLabel || '').replaceAll('__RATING__', String(rating));
        starsHost.replaceWith(createStars(root, rating, starLabel));
      }

      const headingText = String(photo.heading || '').trim();
      const body = String(photo.body || '').trim();
      const headingNode = dialog.querySelector('[data-review-photo-heading]');
      const quoteNode = dialog.querySelector('[data-review-photo-quote]');
      const bodyNode = dialog.querySelector('[data-review-photo-body]');
      if (headingText) {
        if (headingText.length > 120 && quoteNode) {
          quoteNode.hidden = false;
          quoteNode.textContent = headingText;
        } else if (headingNode) {
          headingNode.hidden = false;
          headingNode.textContent = headingText;
        }
      }
      if (bodyNode && body) {
        bodyNode.hidden = false;
        bodyNode.textContent = body;
      }

      const verifiedNode = dialog.querySelector('[data-review-photo-verified]');
      if (verifiedNode && isVerified(photo)) {
        verifiedNode.hidden = false;
        const verifiedLabel = verifiedNode.querySelector('[data-review-photo-verified-label]');
        if (verifiedLabel) verifiedLabel.textContent = config.verifiedLabel || '';
      }

      const trigger = wrap.querySelector('[data-review-open]');
      if (trigger) {
        trigger.setAttribute('data-review-open', '#' + dialogId);
        trigger.setAttribute('aria-controls', dialogId);
        trigger.setAttribute('aria-label', label);
      }

      const thumb = wrap.querySelector('img');
      if (thumb) {
        thumb.src = photo.url;
        thumb.alt = alt;
      }
      const full = dialog.querySelector('[data-review-photo-full]');
      if (full) {
        full.loading = 'eager';
        full.alt = alt;
        full.src = photo.url;
      }

      const holder = document.createDocumentFragment();
      holder.append(wrap, dialog);
      return holder;
    };

    const isExpanded = (root) => root.dataset.reviewsOpened === 'true';

    const filteredList = (root) => {
      const reviews = root._reviewsData || [];
      const rating = root.dataset.reviewsFilter || 'all';
      const photosOnly = root.dataset.reviewsPhotos === 'true';
      return reviews.filter((review) => {
        if (rating !== 'all' && Number(review.rating) !== Number(rating)) return false;
        if (photosOnly && photosOf(review).length === 0) return false;
        return true;
      });
    };

    const collectPhotos = (reviews) => {
      const photos = [];
      reviews.forEach((review) => {
        photosOf(review).forEach((url) => {
          if (photos.some((item) => item.url === url)) return;
          photos.push(photoFromReview(review, url));
        });
      });
      return photos;
    };

    const renderDistribution = (root) => {
      const host = root.querySelector('[data-reviews-distribution]');
      const template = root.querySelector('[data-review-rating-row-template]');
      const config = root._reviewsConfig || {};
      if (!host || !template) return;
      const reviews = root._reviewsData || [];
      const counts = [0, 0, 0, 0, 0];
      reviews.forEach((review) => {
        const rating = Number(review.rating);
        if (rating >= 1 && rating <= 5) counts[rating - 1] += 1;
      });
      const total = reviews.length || 1;
      host.setAttribute('aria-label', config.distributionLabel || '');
      host.replaceChildren();
      [5, 4, 3, 2, 1].forEach((rating) => {
        const fragment = template.content.cloneNode(true);
        const button = fragment.querySelector('[data-reviews-rating-filter]');
        if (!button) return;
        const count = counts[rating - 1];
        button.setAttribute('data-reviews-rating-filter', String(rating));
        const starLabel =
          rating === 1
            ? String(config.filterStar || '').replaceAll('__RATING__', '1')
            : String(config.filterStars || '').replaceAll('__RATING__', String(rating));
        button.setAttribute('aria-label', starLabel);
        const value = button.querySelector('[data-review-rating-value]');
        if (value) value.textContent = String(rating);
        const bar = button.querySelector('[data-review-rating-bar]');
        if (bar) bar.style.width = (count / total) * 100 + '%';
        const countNode = button.querySelector('[data-review-rating-count]');
        if (countNode) countNode.textContent = String(count);
        host.appendChild(button);
      });
    };

    const renderPhotosStrip = (root) => {
      clearPortaledDialogs(root, false);
      const config = root._reviewsConfig || {};
      const expanded = isExpanded(root);
      const limit = expanded
        ? Math.max(0, Number(config.expandedPhotos) || 6)
        : Math.max(0, Number(config.compactPhotos) || 3);
      const photos = collectPhotos(root._reviewsData || []);
      const photoGrid = root.querySelector('[data-reviews-photos-grid]');
      const photoWrap = root.querySelector('[data-reviews-photos]');
      if (photoGrid) {
        photoGrid.replaceChildren();
        photos.slice(0, limit).forEach((photo, index) => {
          const node = createPhoto(root, photo, index, config);
          if (node) photoGrid.appendChild(node);
        });
      }
      if (photoWrap) photoWrap.hidden = photos.length === 0;
    };

    const paintGrid = (root, from, to, append) => {
      if (!append) clearPortaledDialogs(root, true);
      const expanded = isExpanded(root);
      const config = root._reviewsConfig || {};
      const list = expanded ? filteredList(root) : root._reviewsData || [];
      const grid = root.querySelector('[data-reviews-grid]');
      if (!grid) return;
      if (!append) grid.replaceChildren();
      const end = Math.min(to, list.length);
      const fragment = document.createDocumentFragment();
      for (let index = from; index < end; index += 1) {
        const card = createCard(root, list[index], index, expanded, config);
        if (card) fragment.appendChild(card);
      }
      grid.appendChild(fragment);
      root.dataset.reviewsShown = String(end);
      requestAnimationFrame(() => hideOverflowButtons(root));
    };

    const updateChrome = (root) => {
      const expanded = isExpanded(root);
      const config = root._reviewsConfig || {};
      const all = root._reviewsData || [];
      const filtered = filteredList(root);
      const shown = Number(root.dataset.reviewsShown) || 0;
      const limit = Math.max(1, Number(config.limit) || 2);
      const themeCount = String(config.themeCount || '').trim();
      const displayCount = themeCount !== '' ? themeCount : String(all.length);
      root.classList.toggle('reviews--compact', !expanded);

      const expander = root.querySelector('[data-reviews-expand]');
      const expandLabel = root.querySelector('[data-reviews-expand-label]');
      if (expandLabel) {
        expandLabel.textContent = expanded
          ? config.collapseLabel || ''
          : withCount(config.buttonLabel, displayCount);
      }
      if (expander) {
        expander.hidden = all.length <= limit && !expanded;
        expander.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }

      const distribution = root.querySelector('[data-reviews-distribution]');
      if (distribution) distribution.hidden = !expanded;
      const filters = root.querySelector('[data-reviews-filters]');
      if (filters) filters.hidden = !expanded;

      const title = root.querySelector('[data-reviews-list-title]');
      if (title) {
        title.textContent = expanded ? config.expandedHeading || '' : config.listHeading || '';
      }

      const moreWrap = root.querySelector('[data-reviews-more-wrap]');
      if (moreWrap) moreWrap.hidden = !expanded || shown >= filtered.length || filtered.length === 0;

      const moreLabel = root.querySelector('[data-reviews-more-label]');
      if (moreLabel && config.loadMoreLabel) moreLabel.textContent = config.loadMoreLabel;

      const status = root.querySelector('[data-reviews-status]');
      if (status) {
        if (!expanded) {
          status.textContent = '';
        } else {
          const rating = root.dataset.reviewsFilter || 'all';
          const photosOnly = root.dataset.reviewsPhotos === 'true';
          const statusCount =
            rating === 'all' && !photosOnly ? displayCount : String(filtered.length);
          let text = String(config.statusCount || '').replaceAll('__COUNT__', statusCount);
          if (photosOnly && config.statusPhotos) {
            text += ' ' + config.statusPhotos;
          }
          if (rating !== 'all') {
            const star =
              Number(rating) === 1 ? config.filterStar : config.filterStars;
            text += ' · ' + String(star || '').replaceAll('__RATING__', rating);
          }
          status.textContent = text;
        }
      }

      const empty = root.querySelector('[data-reviews-empty]');
      if (empty) {
        if (expanded && filtered.length === 0) {
          empty.hidden = false;
          empty.replaceChildren(document.createTextNode((config.noResults || '') + ' '));
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = config.showAll || '';
          button.setAttribute('data-reviews-reset', '');
          empty.appendChild(button);
        } else {
          empty.hidden = true;
          empty.replaceChildren();
        }
      }
    };

    const renderPhotosAndGrid = (root, from, to, append) => {
      paintGrid(root, from, to, append);
      renderPhotosStrip(root);
      updateChrome(root);
    };

    const openExpanded = (root, rating) => {
      root.dataset.reviewsOpened = 'true';
      if (rating) {
        root.dataset.reviewsFilter = String(rating);
        const select = root.querySelector('[data-reviews-rating-select]');
        if (select) select.value = String(rating);
      }
      const pageSize = Math.max(1, Number((root._reviewsConfig || {}).pageSize) || 6);
      renderPhotosAndGrid(root, 0, pageSize, false);
    };

    const closeExpanded = (root) => {
      root.dataset.reviewsOpened = 'false';
      root.dataset.reviewsFilter = 'all';
      root.dataset.reviewsPhotos = 'false';
      const select = root.querySelector('[data-reviews-rating-select]');
      if (select) select.value = 'all';
      const check = root.querySelector('[data-reviews-photos-only]');
      if (check) check.checked = false;
      const limit = Math.max(1, Number((root._reviewsConfig || {}).limit) || 2);
      renderPhotosAndGrid(root, 0, limit, false);
    };

    const applyFilters = (root) => {
      const pageSize = Math.max(1, Number((root._reviewsConfig || {}).pageSize) || 6);
      paintGrid(root, 0, pageSize, false);
      updateChrome(root);
    };

    const renderReviews = (root, reviews, config) => {
      const limit = Math.max(1, Number(config.limit) || 2);
      const loadedCount = reviews.length;
      const themeCount = String(config.themeCount || '').trim();
      const displayCount = themeCount !== '' ? themeCount : String(loadedCount);
      const sum = reviews.reduce((total, review) => total + (Number(review.rating) || 0), 0);
      const average = loadedCount ? sum / loadedCount : 0;
      const themeRating = String(config.themeRating || '').trim();
      const ratingLabel =
        themeRating !== '' ? themeRating : formatRating(average, config.locale);

      const ratingNode = root.querySelector('[data-reviews-rating]');
      if (ratingNode) ratingNode.textContent = ratingLabel;

      const countNode = root.querySelector('[data-reviews-count]');
      if (countNode) countNode.textContent = withCount(config.countLabel, displayCount);

      const methodNode = root.querySelector('[data-reviews-method]');
      if (methodNode && config.methodBody) {
        methodNode.textContent = withCount(config.methodBody, displayCount);
      }

      root._reviewsData = reviews;
      root._reviewsConfig = config;
      root.dataset.reviewsReady = 'true';
      root.dataset.reviewsLimit = String(limit);
      root.dataset.reviewsOpened = 'false';
      root.dataset.reviewsFilter = 'all';
      root.dataset.reviewsPhotos = 'false';
      renderDistribution(root);
      renderPhotosAndGrid(root, 0, limit, false);
    };

    const bindFilters = (root) => {
      const select = root.querySelector('[data-reviews-rating-select]');
      if (select && !select.hasAttribute('data-bound')) {
        select.setAttribute('data-bound', '');
        select.addEventListener('change', () => {
          root.dataset.reviewsFilter = select.value || 'all';
          if (isExpanded(root)) applyFilters(root);
        });
      }
      const check = root.querySelector('[data-reviews-photos-only]');
      if (check && !check.hasAttribute('data-bound')) {
        check.setAttribute('data-bound', '');
        check.addEventListener('change', () => {
          root.dataset.reviewsPhotos = check.checked ? 'true' : 'false';
          if (isExpanded(root)) applyFilters(root);
        });
      }
    };

    const initRoot = (root) => {
      if (!root || root.hasAttribute(boundAttr)) return;
      root.setAttribute(boundAttr, '');
      hideOverflowButtons(root);
      bindFilters(root);
      const config = readConfig(root);
      if (!config || !config.src) {
        root.setAttribute('aria-busy', 'false');
        return;
      }
      fetch(config.src)
        .then((response) => {
          if (!response.ok) throw new Error('reviews');
          return response.json();
        })
        .then((data) => {
          const reviews = (Array.isArray(data) ? data : [])
            .filter(isApproved)
            .sort((a, b) => {
              // Keep 1★ reviews out of the first fetch / compact list.
              const aOneStar = Number(a.rating) === 1 ? 1 : 0;
              const bOneStar = Number(b.rating) === 1 ? 1 : 0;
              if (aOneStar !== bOneStar) return aOneStar - bOneStar;
              const aDate = parseDate(a.created_at);
              const bDate = parseDate(b.created_at);
              return (bDate ? bDate.getTime() : 0) - (aDate ? aDate.getTime() : 0);
            });
          renderReviews(root, reviews, config);
        })
        .catch(() => {})
        .finally(() => {
          root.setAttribute('aria-busy', 'false');
        });
    };

    const expandRoot = (expander) => {
      const root = expander.closest('[data-reviews]');
      if (!root || root.dataset.reviewsReady !== 'true') return;
      if (isExpanded(root)) {
        closeExpanded(root);
        return;
      }
      openExpanded(root);
    };

    const loadMoreRoot = (button) => {
      const root = button.closest('[data-reviews]');
      if (!root || root.dataset.reviewsReady !== 'true') return;
      const pageSize = Math.max(1, Number((root._reviewsConfig || {}).pageSize) || 6);
      const shown = Number(root.dataset.reviewsShown) || 0;
      paintGrid(root, shown, shown + pageSize, true);
      updateChrome(root);
    };

    const resetFilters = (root) => {
      root.dataset.reviewsFilter = 'all';
      root.dataset.reviewsPhotos = 'false';
      const select = root.querySelector('[data-reviews-rating-select]');
      if (select) select.value = 'all';
      const check = root.querySelector('[data-reviews-photos-only]');
      if (check) check.checked = false;
      applyFilters(root);
    };

    document.querySelectorAll('[data-reviews]').forEach(initRoot);

    if (window.__reviewsSection) return;
    window.__reviewsSection = true;

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-reviews]').forEach(initRoot);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-reviews]').forEach((root) => {
        clearPortaledDialogs(root, false);
        clearPortaledDialogs(root, true);
      });
    });

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-review-open]');
      if (opener) {
        openDialog(opener.getAttribute('data-review-open'));
        return;
      }

      const closer = event.target.closest('[data-review-close]');
      if (closer) {
        closeDialog(closer.closest('dialog'));
        return;
      }

      const dialog = event.target;
      if (dialog && dialog.matches && dialog.matches('dialog.reviews-dialog')) {
        closeDialog(dialog);
        return;
      }

      const more = event.target.closest('[data-review-more]');
      if (more) {
        const card = more.closest('.reviews-card');
        const text = card ? card.querySelector('[data-review-text]') : null;
        if (!text) return;
        const expanded = more.getAttribute('aria-expanded') === 'true';
        more.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        text.classList.toggle('is-clamped', expanded);
        more.textContent = expanded ? more.dataset.labelMore : more.dataset.labelLess;
        return;
      }

      const ratingFilter = event.target.closest('[data-reviews-rating-filter]');
      if (ratingFilter) {
        const root = ratingFilter.closest('[data-reviews]');
        if (root && root.dataset.reviewsReady === 'true') {
          openExpanded(root, ratingFilter.getAttribute('data-reviews-rating-filter'));
        }
        return;
      }

      const reset = event.target.closest('[data-reviews-reset]');
      if (reset) {
        const root = reset.closest('[data-reviews]');
        if (root && root.dataset.reviewsReady === 'true') resetFilters(root);
        return;
      }

      const expander = event.target.closest('[data-reviews-expand]');
      if (expander) {
        expandRoot(expander);
        return;
      }

      const loadMore = event.target.closest('[data-reviews-more]');
      if (loadMore) loadMoreRoot(loadMore);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__sizeGuideSection) return;
    window.__sizeGuideSection = true;

    const openDialog = (selector) => {
      if (!selector) return;
      const dialog = document.querySelector(selector);
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      const focusable = dialog.querySelector('[data-dialog-focus]');
      if (focusable) focusable.focus();
    };

    const closeDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    const showRoom = (dialog, roomId) => {
      if (!dialog || !roomId) return;
      dialog.querySelectorAll('[data-size-guide-tab]').forEach((tab) => {
        tab.setAttribute('aria-pressed', tab.getAttribute('data-size-guide-tab') === roomId ? 'true' : 'false');
      });
      dialog.querySelectorAll('[data-size-guide-panel]').forEach((panel) => {
        panel.hidden = panel.getAttribute('data-size-guide-panel') !== roomId;
      });
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-size-guide-open]');
      if (opener) {
        openDialog(opener.getAttribute('data-size-guide-open'));
        return;
      }

      const tab = event.target.closest('[data-size-guide-tab]');
      if (tab) {
        showRoom(tab.closest('dialog'), tab.getAttribute('data-size-guide-tab'));
        return;
      }

      const closer = event.target.closest('[data-size-guide-close]');
      if (closer) {
        closeDialog(closer.closest('dialog'));
      }
    });

    document.addEventListener('click', (event) => {
      const dialog = event.target;
      if (dialog && dialog.matches && dialog.matches('dialog.size-guide-dialog')) {
        closeDialog(dialog);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tracking"]) return;
  try {
    
  function initTrackingPage(root) {
    if (!root) return;

    const select = root.querySelector('[data-tracking-select]');
    const panels = root.querySelectorAll('[data-tracking-panel]');

    const showPanel = (id) => {
      panels.forEach((panel) => {
        panel.hidden = panel.getAttribute('data-tracking-panel') !== String(id);
      });
    };

    if (select) {
      select.addEventListener('change', () => showPanel(select.value));
    }

    root.querySelectorAll('[data-tracking-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = root.querySelector(`#${CSS.escape(button.getAttribute('data-tracking-open'))}`);
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      });
    });

    root.querySelectorAll('[data-tracking-close]').forEach((button) => {
      button.addEventListener('click', () => button.closest('dialog')?.close());
    });

    root.querySelectorAll('dialog').forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  }

  document.querySelectorAll('[data-tracking-root]').forEach(initTrackingPage);

  } catch(e) { console.error(e); }
})();
})();
